export default {
  hrbee_packages: {
    assets: 'Assets module',
    employee: 'Employee module',
    feeds: 'Feeds module',
    recruitment: 'Recruitment module',
    vacations: 'Vacations module',
    wages: 'Wages module',
    workschedule: 'Workschedule module',
    insurance: 'Insurance module',
    performance: 'Performance module'
  },
  hrbee_packages_descriptions: {
    assets: 'Assets module',
    employee: 'Employee module',
    feeds: 'Feeds module',
    recruitment: 'Recruitment module',
    vacations: 'Vacations module',
    wages: 'Wages module',
    workschedule: 'Workschedule module',
    insurance: 'Insurance module',
    performance: 'Performance module'
  },
  common: {
    yes: 'Po',
    no: 'Jo',
    nodatafound: 'Nuk ka të dhëna',
    edit: 'Ndrysho'
  },
  extra: {
    banktransfer: 'Transfer bankar',
    date: 'Data',
    time: 'Koha',
    type: 'Tipi',
    description: 'Përshkrimi',
    cforcandidate: 'Komenti për kandidatin',
    cbycandidate: 'Komentet prej kandidatit'
  },

  cancel_job: {
    cancel_job_vacancy: 'Anuloni vendin e lirë të punës',
    reason_of_job_cancelation:
      'Ju lutemi shkruani arsyen e anulimit të vendit të lirë të punës',
    candidates_will_be_informed:
      'Të gjithë kandidatët që kanë aplikuar do të informohen për arsyen e anulimit',
    no_access: 'Nuk ka qasje'
  },

  all_notifications: {
    on: 'në',
    at: 'në',
    mark_all_as_read: 'Mark të gjitha si të lexuar',
    no_notifications: 'Nuk keni njoftime të reja',

    invited_to_interview: 'ju ftoi te intervistoni per',
    approved_application: 'miratoi kërkesën tuaj për',
    rejected_application: 'refuzoi aplikimin tuaj për',
    rated_cv: 'vlerësuar CV-në tuaj',

    invite_interview: 'Fto intervistë',
    job_app_accepted: 'Kërkesa për punë u pranua',
    job_app_rejected: 'Kërkesa për punë u refuzua',
    job_app_rated: 'Aplikimi për punë i vlerësuar',

    applied_for: 'aplikuar për',
    accepted_interview: 'pranoi intervistën',
    rejected_interview: 'refuzoi intervistën',
    requested_vacation: 'kërkoi pushime.',
    new_invoice: 'Ju keni një faturë të re',
    for_your_company: ' për kompaninë tuaj',
    approved_module: 'Hr Bee miratoi modulin e',
    rejected_module: 'Hr Bee refuzoi modulin e',

    new_application: 'Aplikim i ri për punë',
    interview_accepted: 'Intervista u pranua',
    interview_rejected: 'Intervista u refuzua',
    vacation_request: 'Kërkesa për pushime',
    invoice: 'Fatura',
    new_module: 'Modul i ri',
    reject_module: 'Moduli i refuzuar',

    approved_vacation_request: 'miratoi kërkesën tuaj për pushime',
    department_lead_approved_vacation_request:
      '{departmentLeadName} miratoi pushimin për {targetEmployeeName}, pritet vendimi i juaj',
    approved_vacation: 'miratoi pushimin',
    rejected_vacation_request: 'refuzoi kërkesën tuaj për pushime',

    vacation_approved: 'Pushimet u miratuan',
    vacation_rejected: 'Pushimet u refuzuan',
    vacation: 'Pushimi',

    access_control_absence:
      'Sistemi ka gjetur një mungesë nga orari i juaj i punës'
  },

  salary_page: {
    primaryjob: 'Puna primare',
    secondaryjob: 'Punë dytësore',
    terminationpay: 'Pagesë për ndërprerjen e kontratës'
  },

  attendance: {
    map: 'Koordinatat e lokacionit',
    checkinlocation: 'Lokacioni i fillimit',
    checkoutlocation: 'Lokacioni i mbarimit',
    delete: 'Fshije',
    get_reports_button: 'Shfaq raportet',
    work_duration: 'Kohëzgjatja e punës',
    pause_duration: 'Kohëzgjatja e pauzës',
    checkin: 'Fillimi',
    checkout: 'Mbarimi',
    type: 'Lloji',
    duration: 'Kohëzgajtja',
    work: 'Punë',
    pause: 'Pauzë',
    add_attendance: 'Shto',
    add_attendance_description: 'Shto orë pune',
    today_attendances: 'Pjesëmarrjet për sot',
    today_schedule: 'Orari punës për sot',
    weekly_schedules: 'Oraret javore',
    monthly_attendances: 'Pjesëmarrjet mujore'
  },

  workschedule: {
    download_daily_reports: 'Download daily reports',
    download_monthly_reports: 'Download monthly reports',
    accesscontrolreports: 'Raportet',
    nologs: 'Nuk ka të dhëna për këtë punonjës',
    date: 'Date',
    checkin: 'Hyrja',
    checkout: 'Dalja',
    checkedin: 'Ka hyrë',
    checkedout: 'Ka dalur',
    byschedulecheckin: 'Hyrja sipas orarit',
    byschedulecheckout: 'Dalja sipas orarit',
    workinghours: 'Orari i punës',
    workedhours: 'Punoi orë',
    absences: 'Mungesat',
    absencenotes: 'Vërejtjet për mungesa',
    editabsence: 'Ndrysho mungesen',
    reasons: 'Arsyet',
    noreason: 'Nuk ka dhënë arsye',
    deductfrompay: 'Hiq nga rroga',
    deductfrompayamount: 'Sasia e heqjes',
    markasresolved: 'Shëno si të zgjidhur',
    details: 'Details',
    minutes: 'minutes',
    type: 'Type',
    totalworkinghours: 'Total working hours: ',
    totalabsencehours: 'Total hours absent: ',
    totalbreakhours: 'Total break hours: ',
    closedetails: 'Mbyll detajet',
    addnewschedule: 'Shto një model të ri të orarit',
    back: 'Prapa',
    name: 'Emrin',
    select_schedule_template: 'Zgjidhni modelin e orarit',
    workingschedule: 'Orari i punës',
    works: 'Punon',
    nowork: 'Nuk Punon',
    start: 'Fillo',
    end: 'Fundon',
    monday: 'E hënë',
    tuesday: 'E marte',
    wednesday: 'E mërkurë',
    thursday: 'E enjte',
    friday: 'E premte',
    saturday: 'E shtune',
    sunday: 'E diel',
    save: 'Ruaj',
    cancel: 'Anulo',
    edit: 'Redakto',
    update: 'Përditeso',
    delete: 'Fshije',
    noschedule: 'Asnjë model orari, ju lutem shtoni të ri',
    noemployee: 'Ju nuk keni asnjë punonjës të shtuar'
  },

  emp_pages: {
    no_general_vacations: 'Nuk ka pushime të përgjithshme nga kompania',
    departments: 'Departamentet',
    department: 'Departamenti',
    position: 'Pozita',
    subdepartments: 'Nën departamentet',
    subsubdepartments: 'Nën nën departamentet',
    positions: 'Pozitat',
    nodresscode: 'Nuk ka kod të veshjes',
    nodresscodedsc:
      'Shkoni te cilësimet e llogarisë dhe shtoni kod të ri të veshjes',
    nodresscodewithsearch: 'Nuk u gjet asnjë kod i veshjes',
    filter: 'Filtro',
    clearfilter: 'Pastro filtrin'
  },

  accsettings_alert: {
    old_pass_wrong: 'Fjalëkalimi i vjetër duhet të jetë i saktë!',
    pass_changed_success:
      'Fjalëkalimi është ndryshuar me sukses, ju lutem identifikohuni përsëri!',
    confirm_pass_wrong:
      'Konfirmimi i fjalëkalimit duhet të jetë i njëjtë me fjalëkalimin e ri!'
  },

  employeeNavigation: {
    feeds: 'Njoftimet',
    profile: 'Profili',
    vacations: 'Pushimet',
    salaries: 'Pagat',
    workingschedule: 'Orari i punës',
    workschedule: 'Orari i punës',
    myschedule: 'Orari im',
    performance: 'Performanca',
    events: 'Ngjarjet',
    todos: 'Për të bërë',
    companyorganogram: 'Organogrami i ndërmarrjes',
    dresscode: 'Kodi i veshjes',
    regulation: 'Rregullorja'
  },

  employmentTypes: {
    full_time: 'Kohë e plotë',
    part_time: 'Me kohë të pjesshme',
    remote: 'Distanca',
    temporary: 'I përkohshëmy',
    contracted: 'Kontraktuar',
    internship: 'Praktikë',
    seasonal: 'Sezonale',
    volunteer: 'Vullnetar'
  },

  navigationCompany: {
    assets: 'Asetet',
    asset_categories: 'Kategoritë',
    support: 'Support - FAQ',
    newsfeed: 'Njoftimet',
    recruitment: 'Rekrutimi',
    jobs: 'Konkurset',
    interviews: 'Intervistat',
    ratings: 'Velersimet',
    blacklist: 'Lista e zezë',
    jobstemplate: 'Shallbonet e Konkurseve',
    searchingemployees: 'Kërko Pune4tor',
    reports: 'Raportet',
    employees: 'Punonjësit',
    dashboard: 'Dashboard',
    allemployees: 'Të gjithë punonjësit',
    documenttemplates: 'Shabllonet e dokumenteve',
    employeeContract: 'Kontratat',
    birthdays: 'Ditëlindjet',
    performanceSettings: 'Cilësimet e Performancës',
    workschedule: 'Orari i punës',
    workschedule_today: 'Pjesëmarrja e sotit',
    all_employees: 'Punëtorët',
    schedule_template: 'Shabllon Oraresh',
    vacations: 'Pushimet',
    vacationrequest: 'Kërkesa për pushime',
    publicholidays: 'Pushime Publike',
    generalvacations: 'Pushimet e Përgjithshme',
    finances: 'Pagat',
    employeesalaries: 'Pagat e punonjësve',
    generatesalaries: 'Gjeneroni pagat',
    wages: 'Kompenzimet',
    timelineproject: 'Projektet',
    training: 'Trajnimet',
    insurance: 'Sigurimet',
    performance: 'Performanca',
    performance_templates: 'Shabllonet e performancave',
    all_employee_performances: 'Performancat e punëtorëve',
    attendances_settings: 'Konfigurimet e pjesëmarrjes',

    paymentsettings: 'Cilësimet e pagesës',
    onmonth: 'Në muaj',
    generatewages: 'Gjeneroni pagat',
    bonuses: 'Bonuset',
    employeeswages: 'Pagat e Punonjësve',
    settings: 'Cilësimet'
  },

  performance: {
    add: 'Shto',
    performances_list_for_section: 'Performanca e këtij seksioni:',
    no_sections_created_yet:
      'Nuk është krijuar ende asnjë seksion i performancës për pozicionin tuaj',
    section_no_performance:
      'Nuk është krijuar ende asnjë performancë për këtë seksion',
    select_month_to_see_ratings:
      'Nëse dëshironi të shihni vlerësimet e performancave, ju lutemi zgjidhni fillimisht muajin',
    performances_employee_title: 'Vlerësime të performancës',
    performances_employee_description:
      'Më poshtë mund të gjeni performancat tuaja të vlerësimit bazuar në seksione',
    show_history: 'Shfaq historikun e vlerësimit',
    hide_history: 'Fshih historikun e vlerësimit',
    for_this_section_there_are:
      'Për këtë seksion dhe për muajin e përzgjedhur ka',
    performances_to_rate_employee:
      'Performancat që mund t`i vlerësoni punonjësit tuaj',
    already_rated_for_this_month:
      'Ju e keni vlerësuar këtë punonjës për muajin e zgjedhur në këtë seksion, kontrolloni historinë tani ->',
    please_select_month:
      'Ju lutemi zgjidhni muajin për të vlerësuar punonjësin tuaj për këtë seksion',
    no_performances_for_this_section:
      'Ende nuk ka performanca për këtë seksion',
    rating_history: 'Historia e vlerësimit',
    performance: 'Performanca',
    rate_for_section: 'Vlerësimi për këtë seksion',
    performance_sections: 'Seksionet e performancës',
    section: 'seksioni',
    percentage_in_total_of_section: 'Në total të seksionit të zgjedhur',
    of_section: 'të seksionit',
    add_performance_for_section: 'Shto seksionin e performancës',
    rate_type: 'Lloji i vlerësimit',
    list_of_performances_for_title:
      'Lista e shfaqjeve për seksionin e zgjedhur',
    list_of_performances_for_description:
      'Lista e shfaqjeve për seksionin e zgjedhur',
    add_performance_for_section_title:
      'Shto performancën për seksionin e zgjedhur',
    add_performance_for_section_description:
      'Shto performancën për seksionin e zgjedhur',
    performances: 'Performancat',
    add_section_performance: 'Shto seksion',
    percentage_of_section: 'Përqindja e seksionit në shabllonin e performancës',
    in_total_perfomance: 'në performancën totale',
    add_performance_button: 'Shtoni performancën',
    add_performance_title: 'Krijo një kriter të performancës',
    add_performance_description: 'Kontrata me kanalet e punonjësve',
    add_performance_section_title: 'Krijo një seksion',
    add_performance_section_description:
      'Krijo një seksion me kriteret e performancës',

    rating_item_type_numbers_title: 'Rating measure performance',
    rating_item_type_numbers_description: 'Matni performancën sipas vlerësimit',

    rating_item_type_scale_title: 'Rating measure performance',
    rating_item_type_scale_description:
      'Matni performancën sipas rankut 1 deri ne 5',

    rating_item_type_percentage_title: 'Krahasueshmëria matë performancën',
    rating_item_type_percentage_description:
      'Ky kriter mund të përdoret për të matur nivelin e arritjeve sipas krahasueshmërisë',
    target_you_achived: 'Objektivi që keni arritur',
    target_you_have: 'Objektivi që keni',
    taget_you_achived_percentage: 'Objektivi që keni arritur në %',

    rating_item_type_text_title: 'Kutia e tekstit',
    rating_item_type_text_description:
      'Punonjësit mund të shkruajnë atë që kanë për të thënë në përgjithësi',

    alert_select_type_of_rating:
      'Ju lutemi zgjidhni një nga llojet e vlerësimeve',

    performance_templates: 'Shabllonet e performancës',
    performance_page_title: 'Performanca e punonjësve',
    performance_page_description:
      'Më poshtë mund të gjeni punonjësit tuaj, mund të zgjidhni një prej tyre dhe të vlerësoni performancën',

    no_templates_available_for_current_position_of_employee:
      'Nuk ka modele të performancës në dispozicion për pozicionin aktual të këtij punonjësi. Ju lutemi shkoni te modelet e performancës dhe krijoni një të tillë.',

    month: 'Muaji',
    year: 'Viti',
    text: 'Teksti'
  },

  month_value: {
    1: 'Janar',
    2: 'Shkurt',
    3: 'Mars',
    4: 'Prill',
    5: 'Maj',
    6: 'Qershor',
    7: 'Korrik',
    8: 'Gusht',
    9: 'Shtator',
    10: 'Tetor',
    11: 'Nëntor',
    12: 'Dhjetorë'
  },

  alertscompany: {
    job_addeed: 'Puna juaj u shtua me sukses',
    job_cantadded: 'Ju lutemi të plotësoni të gjitha fushat e kërkuara (*)',
    job_edited: 'Puna juaj u azhurnua me sukses',
    rated_added: 'Ju e vlerësuat me sukses këtë kandidat',
    addcancelreason: 'Ju lutemi shtoni një arsye të anulimit',
    invitedtointerview:
      'Ftesa për intervistë i është dërguar me sukses kandidatit',
    cantadd: 'Ju lutemi plotësoni të gjitha fushat e kërkuar (*)',
    rejectedcandidate:
      'Ju refuzuat kandidatin nga kjo pozitë, kandidati do të informohet',
    blacklistedcandidate:
      'Ju keni futur në listën e zezë kandidatin, kandidati do të informohet se ai është refuzuar për këtë pozit',
    hiredcandidate:
      'Ju keni punesuar me sukses kandidatin. Duhet qe ta shtoni edhe tek moduli i punonjesve per ta permbyllur procesin',
    potentialcandidate:
      'Kandidati u shtua në listën e kandidatëve të mundshëm/potencial'
  },

  jobStatusTypes: {
    status: 'Statusi i punës',
    active: 'Aktiv',
    draft: 'I draftuar',
    canceled: 'Anuluar',
    finished: 'I përfunduar',
    cancel_job: 'Anulo konkursin'
  },

  job_aplication_status: {
    applied_on: 'Aplikuar me',
    rate_candidate: 'Vlerësoni',
    change_status: 'Ndrysho statusin',
    interview_details: 'Detajet e intervistës',
    blacklisted_details: 'Detaje rreth listës së zezë',
    refuse_candidate_application_details:
      'Detaje rreth refuzimit të aplikimit të kandidatit.',
    reason_for_blacklist: 'Arsyeja pse e futët në listën e zezë këtë kandidat',
    reason_for_decline: 'Arsyeja pse refuzuat aplikimin për kandidat',
    interview_category: 'Lloji i intervistës',
    in_person_interview: 'Në intervistë personale',
    phone_call: 'Telefonatë',
    online_interview: 'Intervista online',
    interview_date: 'Data e intervistës',
    interview_time: 'Koha e intervistës',
    interview_description: 'Përshkrimi i intervistës',
    interview_comments: 'Komentet e intervistës',
    new_application: 'Aplikim i ri',
    rejected_candidate: 'Refuzo aplikimin',
    invited_to_interview: 'Ftohet për intervistë',
    blacklisted: 'Listë e zezë',
    accepted_interview: 'Prano intervistën',
    rejected_interview: 'Refuzoni intervistën',
    potential_candidate: 'Kandidati potencial',
    hired_candidate: 'Kandidat i punësuar',
    job_seeker_reference_letter: 'Referencat',
    job_seeker_reference_letter_doesnt_exists: 'Referencat nuk janë shtuar',
    job_seeker_cover_letter: 'Letër përcjellëse',
    job_seeker_cover_letter_doesnt_exists: 'Letra përcjellëse nuk është shtuar'
  },

  company_jobs_page: {
    exportjobdetails: 'Eksporto detajet e konkursit',
    need_to_be_approved: 'Konkursi i punës do të aprovohet nga administratori',
    approved: 'Konkursi i punës është i aprovuar dhe i publikuar',
    filterjobsbtn: 'Filtroni konkurset',
    cancelbtn: 'Anulo',
    addnewjobbtn: 'Shto konkurs të ri',
    titlejob: 'Titulli i Konkursit',
    statusjob: 'Statusi i konkursit: ',
    ongoing: 'Aktiv',
    pending: 'Në pritje',
    canceled: 'Anuluar',
    completed: 'I përfunduar',
    published: 'Publikuar',
    typejob: 'Lloji i punës',
    deadline: 'Afati i fundit',
    applications: 'Aplikimet',
    viewcandidates: 'Shikoni kandidatët',
    editinterviewpanel: 'Ndrysho panelin',
    selectinterviewpanelmember:
      'Zgjidhni punonjësit që do të jenë pjesë e panelit intervistues',
    editvacancy: 'Redakto konkursin',
    deletevacancy: 'Fshije',

    nojobspublished: 'Nuk keni ende ndonjë konkurs të publikuar',
    nojobsbysearch: 'Nuk ka punë me këtë kërkim',
    searchjobplaceholder: 'Kërkoni punë dhe shtypni enter',
    searchcandidateplaceholder: 'Emri & mbiemri i kandidatit',
    namesurname: 'Emri & mbiemri',
    email: 'Email adresa',
    phonenumber: 'Numri i telefonit (+383XXXXXXXX)',

    filterjobs: 'Filtroni konkurset',
    filterjobsdsc: 'Përgatitja e konkurset përmes këtyre filtra',
    filterbystatus: 'Filtro sipas statusit',
    filterbystatusph: 'Zgjidhni statusin',
    filterbyyear: 'Filter sipas vitit',
    filterbyyearph: 'Zgjidhni vitin',
    filterbymonth: 'Filtro sipas muajit',
    filterbymonthph: 'Zgjidhni muajin',
    filterbytype: 'Filtro sipas llojit',
    filterbytypeph: 'Zgjidhni llojin',
    applyfiltersbtn: 'Apliko filtrat',

    filtercandidates: 'Filtroni kandidatët',
    filtercandidatesdsc:
      'Përgatitja e listës suaj të kandidatëve sipas këtyre filtërve',
    filterbygender: 'Filtro sipas gjinisë',
    filterbygenderph: 'Zgjidhni gjininë',
    filterbyeducation: 'Filtro sipas arsimit',
    filterbyeducationph: 'Zgjidhni nivelin e arsimit',
    filterbyfieldofstudy: 'Filtro sipas fushës së studimit',
    filterbyfieldofstudyph: 'Zgjidhni fushën e studimi',
    filterbyskills: 'Filtro sipas aftësive',
    filterbyskillsph: 'Zgjidhni aftësinë',
    filterbyrate: 'Filtro sipas normave',
    filterbyrateph: 'Zgjidh norma',
    filterbylanguages: 'Filtro sipas gjuhëve',
    filterbylanguagesph: 'Zgjidh gjuhen',
    filterbyyearsofexperience: 'Filtro sipas viteve të përvojës',
    filterbyyearsofexperienceph: 'Zgjidhni vitin e përvojës',
    filterbymotivationletter: 'Filtro me letër motivimi',
    filterbymotivationletterph: 'Trego kandidatët me letër motivuese',
    filterbyreferenceletter: 'Filtroni me letër referimi',
    filterbyreferenceletterph: 'Trego kandidatët me letër referuese',

    clearfiltersbtn: 'Pastroni filtrat',
    clearfilters: 'Pastroni filtrat',
    backbtn: 'Prapa',

    selectedcandidate: 'Kandidatët e përzgjedhur',
    rejectedcandidate: 'Kandidati i refuzuar',
    potentialcandidates: 'Kandidatët e mundshëm',

    appliedon: 'Aplikuar në: ',
    invitedforinterview: 'I ftuar për intervistë',
    interviewaccepted: 'Intervista e pranuar nga kandidati',
    rejectedcandidatebycompany: 'Kandidat i refuzuar nga kompania',
    rejectedinterview: 'Intervistë e refuzuar nga kandidati',
    blacklistedcandidate: 'Kandidat në listë të zezë',
    ratedcandidate: 'Kandidat i vlerësuar',
    hiredcandidate: 'Hired candidate',
    potentialcandidate: 'Kandidati potencial',

    sorrynojobapplications: 'Na vjen keq, nuk keni ndonjë kërkesë për punë',

    titlecandidate: 'Titulli',
    birthday: 'Ditëlindja',
    citycountry: 'Qytet & Shtet',
    socialmedia: 'Mediat sociale: ',
    shortbio: 'Biografi e shkurtër: ',

    experience: 'Përvoja',
    noexperience: 'Asnjë përvojë e shtuar',
    education: 'Edukimi',
    schoolname: 'Emri i shkollës',
    fieldofstudy: 'Fusha e studimit',
    fromupto: 'nga - deri me',
    levelofeducation: 'Niveli i arsimimit',
    file: 'File',
    noeducation: 'Asnjë arsim i shtuar',

    trainings: 'Trajnime',
    institution: 'Institucioni',
    trainingcourse: 'Trajnimi / Kursi',
    notrainings: 'Asnjë trajnim / kurse i shtuar',

    languages: 'Gjuhët',
    language: 'Gjuha',
    reading: 'Leximi',
    understanding: 'Të kuptuarit',
    speaking: 'Të folurit',
    writing: 'Të shkruarit',
    nolanguages: 'Asnjë gjuhë e shtuar',

    itskills: 'Aftësi IT',
    skill: 'Aftësi',
    level: 'Niveli',
    noitskills: 'Nuk ka aftësitë kompjuterike shtuara',

    otherskills: 'Aftësi të tjera',
    nootherskills: 'Nuk ka aftësi të tjera të shtuara',

    drivinglicence: 'Patentë shoferi',
    nootherdrivinglicence: 'Nuk ka te shtuara',

    referenceletter: 'Letër reference',
    noreferenceletter: 'Asnjë letër referimi',

    requiredreferenceandmotivation:
      'Nëse dëshironi letër referimi dhe motivimi, ju lutemi zgjidhni',
    motivationletter: 'Letër motivimi',
    nomotivationletter: 'Asnjë letër motivimi',

    rateeducation: 'Vlerësoni shkollimin',
    ratelanguages: 'Vlerësoni gjuhët',
    rateexperience: 'Vlerësoni përvojën',
    profileexperience: 'Përvoja e profilit',
    generalknowledge: 'Njohuri të përgjithshme',
    judgementcapability: 'Aftësit e gjykimit',
    knowledgeaboutposition: 'Njohuri në lidhje me pozitën',
    logicalquestions: 'Pyetje logjike',
    totalaveragerating: 'Vlera mesatare totale',
    ratecandidate: 'Vlerësoni kandidatin',
    noteforcandidate: 'Shënim për kandidatin',
    finaldecision: 'Vendimi përfundimtar',

    publishjobbtn: 'Publiko Konkursin',
    saveastemplatebtn: 'Rauj si shabllon',

    previewofjobtemplate: 'Paraqitje e Shabllonit të konkursit',
    titleofjobtemplate: 'Titulli i Shabllonit të konkursit',

    editjob: 'Redakto konkursin',
    updatejob: 'Përditëso konkursin',

    viewblacklistedcandidates: 'Shikoni kandidatët në listën e zezë',
    noblacklistedcandidate: 'Ju nuk keni ndonjë kandidat në listën e zezë',
    reason: 'Arsyeja: ',
    details: 'Detajet',
    viewapplication: 'Shikoni aplikacionin',
    removefromblacklist: 'Fshij nga lista e zezë',

    viewratedcandidates: 'Shikoni kandidatët e vlerësuar',
    noratedcandidate: 'Ju nuk keni ndonjë kandidat të vlerësuar',

    viewinterviewcandidates: 'Shikoni kandidatët për intervistë',
    nointerviewcandidate: 'Ju nuk keni ndonjë kandidat për intervistë',

    noinvitedcandidate: 'Ju nuk keni ndonjë kandidat të ftuar',
    noacceptcandidate: 'Asnjë kandidat nuk e ka pranuar ftesën për intervistë',
    norejectcandidate: 'Asnjë kandidat nuk e ka refuzuar ftesën për intervistë',
    nointerviewcandidatewithsearch:
      'Nuk mund të gjesh asnjë kandidat me atë emër',

    invitedinterview: 'I ftuar për intervistë',
    acceptinterview: 'Intervistat e pranuara',
    rejectinterview: 'Intervistat e refuzuara',

    usethistemplate: 'Përdorni këtë shabllon',
    notemplate: 'Ju nuk keni ndonjë shabllon të konkursit',

    noteaboutcandidate: 'Shënim për kandidatin',

    searchbyname: 'Kërkoni me emrin e kandidatit',
    searchbyjobtitle: 'Kërkoni sipas titullit të konkursit',

    decisionforcandidate: 'Vendimi për kandidatin',

    nextstage: 'Faza tjetër',
    nextstagedc: 'Faza tjetër',

    interviewcategory: 'Kategoria e intervistës',
    interviewcategorydc: 'Zgjidhni kategorinë e intervistës',
    interviewdate: 'Data e intervistës',
    interviewtime: 'Koha e intervistës',
    'noteforcandidate-senttocandidate':
      "Shënim për kandidatin (do t'i dërgohet kandidatit)",
    'noteforcandidate-senttocandidatedc':
      'Ju lutemi sillni laptopin tuaj me vete ...',
    'noteforcandidate-private':
      "Shënim për kandidatin (nuk do t'i tregohet kandidatit)",
    'noteforcandidate-privatedc':
      "Kjo fushë nuk do t'i tregohet kandidatit. Është vetëm për kompaninë tuaj",
    invitetointerviewbtn: 'Fto për intervistë',

    rejectreason:
      'Kandidati do të informohen arsyen e refuzimit  nga kjo pozitë',
    rejectreasondc:
      'Ju lutemi shkruani arsyen e refuzimit për këtë kandidat ...',

    applytemplate: 'Aplikoni shabllonin',
    rejectcandidate: 'Refuzo kandidatin',
    blacklistcandidate: 'Kandidati në listën e zezë',

    blacklistreason: 'Arsyeja e listës së zezë të kandidatit',
    blacklistreasondc:
      'Ju lutemi shkruani arsyen e listës së zezë për këtë kandidat ...',

    makepotentialcandidate: 'Beje kandidat potencial',
    hirethiscandidate: 'Punësoni këtë kandidat',
    applyfilters: 'Apliko filtrat',

    addnewtemplate: 'Shto Shabllon të ri',
    doctemplates: 'Shabllonet e dokumenteve',
    contracttemp: 'Shabllonet e kontratave',
    vacationstemp: 'Shabllonet e pushimeve',
    warninglettertemp: 'Shabllone e letrave paralajmëruese',
    sorrynotemp: 'Ju nuk keni ndonjë shabllon të dokumenteve'
  },

  company_blacklist: {
    reason: 'Arsyeja',
    jobseekername: 'Emri që përputhet me',
    jobseekeremail: 'Emaili që përputhet me',
    jobseekerphonenumber: 'Numri i telefonit që përputhet me',
    usersblacklisted: 'Përdoruesit e vendosur në listën e zezë',
    numberofusersblacklisted:
      'Numri i përdoruesve të vendosur në listën e zezë',
    viewusers: 'Shfaq përdoruesit',
    createblacklist: 'Krijo listë të zezë',
    editblacklist: 'Ndrysho listën e zezë',
    deleteblacklist: 'Fshij listën e zezë',
    removeuserseditwarning:
      'Ndryshimi i listës së zezë me këto informata do te shkaktoj heqjen e këtyre përdoruesve nga lista e zezë, a jeni të sigurtë?',
    removeusersdeletewarning:
      'Fshirja e listës së zezë do te shkaktoj heqjen e këtyre përdoruesve nga lista e zezë, a jeni të sigurtë?',
    userremoved: 'Përdoruesi u hoq nga lista e zezë',
    noblacklistedusers: 'Nuk ka përdorues',
    createnewblacklistforremovedusers:
      'Krijo një listë të zezë të re për këta përdorues',
    noblacklists: 'Ju nuk keni lista të zeza'
  },

  invite_manual_section: {
    invitemanual: 'Ftesë manuale',
    invitejobseekermanual: 'Ftesë manuale për punëkërkues',
    experience: 'Eksperienca',
    stillworking: 'Prezent',
    notworking: 'E përfunduar',
    cancel: 'Anulo',
    invitenow: 'Dërgo ftesën'
  },

  salaryTypes: {
    salary_net: 'Paga Neto',
    salary_bruto: 'Paga Bruto',
    GROSS: 'Paga Bruto',
    NET: 'Paga Neto',
    null: 'Lloji i pagës'
  },

  VacationLeaveTypes: {
    yearly_leave: 'Pushime vjetore',
    sick_leave: 'Pushimi mjekësor',
    marriage_leave: 'Pushimi martesor',
    maternity_leave: 'Pushimi i lehonisë',
    daily_leave: 'Leje ditore',
    death_leave: 'Pushimi Mortor',
    paternity_leave: 'Pushimi i atësisë',
    blood_donation_leave: 'Pushimi për dhurimi të gjakut',
    compensation_leave: 'Pushim me pagesës',
    overtime: 'Jashtë orarit',
    unpaid_leave: 'Pushim pa pagesë'
  },

  assets: {
    image: 'Foto',
    add: 'Shto',
    change: 'Ndrysho',
    status: 'Statusi',
    available: 'Në dispozicion',
    assigned: 'Caktuar',
    in_maintenance: 'Në mirëmbajtje',
    retired: 'Tërhequr',
    current_status: 'Statusi aktual',
    unique_identifier: 'Identifikues unik',
    identifier_input_mode: 'Menyra e identifikuesit',
    identifier_mode_auto: 'Gjenero automatikisht',
    identifier_mode_manual: 'Shkruaj manualisht',
    identifier_auto_placeholder: 'Identifikuesi do te gjenerohet automatikisht',
    identifier_auto_help:
      'Një identifikues unik do të gjenerohet kur ta ruani asetin.',
    qr_code: 'Kodi QR',
    qr_code_description:
      'Skano këtë kod QR për të lexuar identifikuesin unik të asetit.',
    qr_code_not_available: 'Kodi QR nuk është i disponueshëm për këtë aset.',
    download_qr_code: 'Shkarko kodin QR',
    print_qr_code: 'Printo kodin QR',
    export_available: 'Eksporto asetet e lira',
    export_assigned: 'Eksporto asetet e caktuara',
    export_current_view: 'Eksporto pamjen aktuale',
    export_all: 'Eksporto të gjitha',
    export_assets: 'Eksporto ne Excel',
    exporting_assets: 'Duke eksportuar...',
    created_date: 'Data e krijimit',
    no_assets_to_export: 'Nuk ka asete për eksport.',
    filter_by_status: 'Filtro sipas statusit',
    all_statuses: 'Të gjitha statuset',
    available_assets: 'Asetet në dispozicion',
    unassigned_assets: 'Asetet e pacaktuara',
    assigned_assets: 'Asetet e caktuara',
    search_assets: 'Kerko asetet sipas emrit ose identifikuesit unik',
    search_assets_placeholder: 'Kerko',
    search_results: 'Rezultatet e kerkimit',
    no_search_results: 'Nuk u gjet asnje aset me filtrat aktual.',
    filter_by_category: 'Filtro sipas kategorise',
    clear_filters: 'Pastro filtrat',
    rows_per_page: 'Rreshta per faqe',
    deleted_category: 'Kategori e fshire',
    select_asset_category: 'Selekto kategorine',
    category_name: 'Emri kategorise',
    new_asset_category: 'Regjistro kategori per asete',
    assets: 'Asetet',
    asset: 'Aset',
    new_asset: 'Regjistro Asete',
    assign_asset: 'Cakto Asetin',
    select_asset: 'Zgjidhni Asetin',
    assignment_date: 'Caktimi i datës',
    return_date: 'Data e Kthimit',
    return_asset: 'Kthimi i Asetit',
    note: 'Sh⌂nime',
    no_data: 'Ende nuk ka asete te regjistruara',
    title: 'Titulli',
    serial_number: 'Numri Serik',
    edit_asset: 'Ndrysho Asetin',
    delete_asset: 'Fshije Asetin',
    assigned_to: 'Caktuar për',
    asset_history: 'Historia e Aseteve'
  },

  employee_module: {
    vacation: 'Pushimi',
    contract_number: 'Numri kontrates',
    startjoblaterthan: 'Fillimi i punes jo me vone se',
    calculateVacationUnusedDays: 'Llogaritni ditët e pushimeve',
    deadline: 'Afati i fundit',
    markedascompleted: 'Shënuar si të përfunduar',
    createtodo: 'Krijo për të bërë',
    title: 'Titulli',
    description: 'Pershkrimi',
    todos: 'Për të bërë',
    notodosfound: 'Nuk ka asnjë detyrë të krijuar për këtë punonjës',
    phonenumber: 'Numri i telefonit',
    salaryamount: 'Shuma e pagës',
    monthly_working_days: 'Ditë pune mujore',
    job_description: 'Përshkrimi i punës',
    accesscontrolid: 'ID kontrollit hyrës',
    requestdate: 'Data e kërkesës',
    vacationyear: 'Pushimi i vitit',
    editdocumenttemplate: 'Ndrysho shabllonin',
    delete: 'Fshije',
    download: 'Shkarko',
    notapproved: 'Pa aprovuar',
    startdatevacation: 'Data e fillimit të pushimit',
    enddatevacation: 'Data e mbarimit të pushimit',
    totaldays: 'Gjithsej ditë',
    accumulatemonthly: 'Grumbullohen çdo muaj',
    halfdays: 'Gjysmë dite',
    total_days: 'Gjithsej ditë',
    selectvacationtemplate: 'Zgjidhni modelin e pushimeve',
    married: 'I martuar',
    not_married: 'I pamartuar',
    addnewdocument: 'Shto dokument',
    expire: 'Data skadimit',
    expiry_date: 'Data e skadimit',
    nogeneralvacations: 'Nuk ka pushime gjenerale per kompanine tuaj',
    nogeneralvacationsdsc:
      'Ju lutem shkoni tek moduli pushimeve dhe krijoni pushimet gjenerale',
    yes: 'Po',
    no: 'Jo',
    addthisemployeetowageslist: 'Shto punëtorin në listën e pagave',
    issecondjob: 'A është punë dytësore?',
    healthinsurancemonthlycost: 'Kosto mujore e sigurimit shëndetsor',
    newemployeebtn: 'Shto punonjës të ri',
    noemployee: 'Ju nuk keni asnjë punonjës të shtuar',
    applyfilters: 'Apliko filtrat',
    apply: 'Aplikoni',

    addnewtemplate: 'Shto Shabllon të ri',
    doctemplates: 'Shabllonet e dokumenteve',
    contracttemp: 'Shabllonet e kontratave',
    vacationstemp: 'Shabllonet e pushimeve',
    warninglettertemp: 'Shabllone e letrave paralajmëruese',
    sorrynotemp: 'Ju nuk keni ndonjë shabllon të dokumenteve',

    profilecv: 'Profili i CV',
    employeeinfo: 'Informatat e Punonjësit',
    contract: 'Kontrata',
    contracthistory: 'Historia e kontratave',
    vacations: 'Pushimet',
    performance: 'Performanca',
    salary: 'Pagat',
    warningletter: 'Vrejtjet',
    otherdocuments: 'Dokumente të tjera',
    access: 'Akses',

    personalinformation: 'Informata personale',
    accountinformation: 'Informacioni i llogarisë',
    pw: 'Gjenero fjalëkalim të ri dhe dërgo email',
    changepw: 'Ndrysho fjalëkalimin',
    employeeworking: 'Punonjësi aktualisht po punon në kompaninë tonë',
    female: 'Femër',
    male: 'Mashkull',

    bankinformation: 'Informacione bankare',
    bankname: 'Emri i bankes',
    banknumber: 'Numri i llogarisë bankare',
    banknamedc: 'Emri i bankës ...',

    emergencyinformation: 'Informacioni i urgjencës',
    bloodgroup: 'Grupi i gjakut',
    bloodgroupdc: 'Zgjedhin grupin e gjakut',
    contactperson: 'Personi i kontaktit',
    contactpersondc: 'Emri i personit të kontaktit ...',
    contactpersonphone: 'Telefoni i personit të kontaktit',
    contactpersonphonedc: 'Telefoni i personit të kontaktit...',

    booktimeoff: 'Rezervoni kohën e lirë',
    booktimeofffromcompany:
      'Si kompani ju mund të rezervoni pushim për një punonjës direkt dhe ta aprovoni atë',
    editvacation: 'Ndrysho pushimin e punonjësit',
    editvacationdc: 'Si kompani ju mund të ndryshoni pushimin e punëtorit',
    vacationtype: 'Lloji i pushimeve',
    selectvacationtype: 'Zgjidhni llojin e pushimeve',
    vacationreplacedby: 'Zevendesuar nga',
    selectvacationreplacedby: 'Cakto personin qe te zevendson',
    startdate: 'Data e fillimit',
    enddate: 'Data e përfundimit',
    halfday: 'Duhet vetëm një ditë e gjysmë pushim',
    reason: 'Arsyeja',
    reasondc: 'Ju lutemi shkruani arsyen e pushimeit...',

    contractstartdate: 'Data e fillimit të kontratës',
    contractenddatetoggle: 'Kontrata me afat të pacaktuar',
    indefiniteterm: 'Pacaktuar',
    contractenddate: 'Data e përfundimit të kontratës',
    chooseposition: 'Zgjidhni pozitën',
    from: 'Nga',
    upto: 'Deri',
    workplace_location: 'Lokacioni i vendit të punës',
    employmenttype: 'Lloji i punësimit',
    current_address: 'Adresa aktuale',

    contractinformation: 'Informacioni i kontratës',
    salaryinformation: 'Informacioni i pagës',
    paymentcurrency: 'Valuta e pagesës',
    selectpaymentcurrency: 'Zgjidhni valutën e pagesës',
    paymentcurrencyhelp:
      'Zgjidhni valutën që përdoret për këtë punonjës para gjenerimit të pagës.',
    paymentcurrencyrequired: 'Valuta e pagesës është e detyrueshme.',
    salary_range_allowed: 'Intervali i lejuar: {min} - {max} {currency}',

    performancetools: 'Mjetet e Performancës',
    addnewperformance: 'Shto performancë të re',
    editperformancebtn: 'Redakto',
    deleteperformancebtn: 'Fshije',
    noperformance: 'Ju nuk keni shtuar ndonjë performancë',
    noperformancedc:
      'In order to add a user performance review, first you need to create a configuration for your performances',
    performancename: 'Titulli',
    performanceratinginterval: 'How often should employees be rated?',
    selecttypeperformance: 'Select a type of performance',
    performancetype: 'Performance type: ',
    rateperformance: 'Rate performance',
    yearforrating: 'Year for rating',
    yearforratingdc: 'Select year for rating',
    monthforrating: 'Month for rating',
    monthforratingdc: 'Select month for rating',

    addemployees: 'Shtoni punonjës',
    addemployeesdsc:
      'Shtoni punonjësit tuaj permes ketyre opcioneve duke klikuar butonat',
    byrecruitment: 'Me rekrutim',
    manual: 'Manual',

    nojobseekerwithhiredstatus:
      'Asnjë punëkërkues me status i punësuar nuk u gjet',

    personalinfo: 'Informata personale',
    accinfor: 'Informacioni i llogarisë',

    idcardno: 'Nr. Amë i të punësuarit në Kompani',
    idcardnodc: 'ID e punëtorit',
    department: 'Departamenti',
    position: 'Pozita',
    accemail: 'Email përdorues i llogarise',
    startjob: 'Fillo punën',
    phone: 'Numri i telefonit',
    personalid: 'Personal ID',

    hirethisemployee: 'Punësoni këtë punonjës',

    filteremployees: 'Filtroni punonjësit',
    clearfilters: 'Pastroni filtrat',
    filteremployeesdc:
      'Përgatitja e listës së punonjësve permes këtyre filtrave',

    filterbydepartment: 'Filtro sipas departamentit',
    filterbyposition: 'Filtro sipas pozitës',
    filterbygender: 'Filtro sipas gjinisë',
    filterbycity: 'Filtro sipas qytetit',

    generatesalary: 'Gjeneroni pagë',
    salaryfor: 'Paga për',
    salarytype: 'Lloji i pagës',
    grosssalary: 'Paga bruto',
    taxes: 'Taksat',
    rankjob: 'Rangu i punës',
    primaryjob: 'Puna primare',
    secondaryjob: 'Punë dytësore',
    date: 'Data',
    contribution: 'Kontributi',
    totaltax: 'Taksa totale',
    netsalary: 'Paga Neto',
    nosalarygenerated: 'Ky punonjës nuk ka asnjë pagë të gjeneruar',

    editmonthly: 'Redaktoni detajet e raportit mujor',
    selectyear: 'Zgjidhni vitin',
    selectmonth: 'Nga muaji',
    formonth: 'Për muajin',
    selecttomonth: 'Deri në muajin',
    isthissecondaryjob: 'A është kjo punë dytësore?',
    advancedpayment: 'Parapagim',
    leavewithoutpayment: 'Pushim pa pagesë',
    bonuspayment: 'Pagesa e bonusit',
    savereport: 'Ruaj raportin',

    nodocuments: 'Ju nuk keni asnjë dokument të shtuar',

    selectcontract: 'Zgjidhni kontratën',
    selectwarningletter:
      'Zgjidhni letrën paralajmëruese nga shabllonet tuaja të dokumenteve',

    nameandsurname: 'Emri dhe mbiemri',
    personalID: 'ID personale',
    employeeID: 'ID e punonjësve',
    address: 'Adresa',
    startdatecontract: 'Data e fillimit të kontratës',
    enddatecontract: 'Data e përfundimit të kontratës',
    ceo: 'CEO',
    fiscalnumber: 'Numri fiskal',
    companyaddress: 'Adresa kompanise',
    companycity: 'Qyteti i kompanise',
    headofhr: 'Drejtori i HR',

    contracttermination: 'Shkëputja e kontratës',
    contractterminationbtn: 'Shkëput kontratën',
    editcontractterminationbtn: 'Ndrysho detajet e shkëputjes së kontratës',
    contractterminationgrosspay: 'Paga bruto e shkëputjes',
    contractterminationreason: 'Arsyeja e shkëputjes',

    leavehistory: 'Historia e pushimeve për vitin',
    noleaves: 'Nuk ka pushime për këtë vit',

    genderstatistics: 'Statistikat e gjinive',
    marriagestatistics: 'Statistikat e martesave',
    nationalitystatistics: 'Statistikat e nacionaliteteve',
    employmenttypestatistics: 'Statistikat e llojit të punësimit',
    activestatusstatistics: 'Statistikat e aktivitetit',
    averageSalary: 'Statistikat e pagave'
  },

  alerts_employee_module: {
    update_document_template: 'Shabllonni u përditësua me sukses',
    update_employee: 'Informacioni i punonjësve u përditësua me sukses',
    vacationfromcompany:
      'Rezervimi i koha se4 pushimit është ruajtur me sukses',
    vacationdaysexist: 'Tani më keni kërkuar për këto data pushimesh.',
    rateperformance: 'Ju e vlerësuat me sukses performancën për këtë kandidat',
    newemployee: 'Punësuat me sukses një punonjës të ri',
    emailunique: 'Ky e-mail eshte i zene',
    deletetemplate: 'Shablloni u fshi me sukses',
    somethingwentwrong: 'Diçka shkoi keq, ju lutem provoni përsëri',
    templateadded: 'Shablloni i dokumentit u shtua me sukses'
  },

  payroll_currency: {
    confirm_single_employee_mismatch:
      'Ky punonjës përdor një valutë tjetër pagese. Të vazhdohet me konvertim?',
    confirm_multiple_employee_mismatch:
      'Disa punonjës përdorin valutë tjetër pagese. Të vazhdohet me konvertim?',
    shown_in: 'Shfaqur në',
    converted_from: 'Konvertuar nga',
    conversion_rate: 'Kursi i konvertimit'
  },

  inputs_employee_module: {
    title: 'Titulli',
    type: 'Lloji',
    selecttype: 'Zgjidhni llojin',
    templatecolumns: 'Numri i kolonave'
  },

  employee_access: {
    access: 'Vendose aksesin të punëtorit',
    selectpackage: 'Zgjidh pakon',
    accesstype: 'Lloji i aksesit',
    accessdepartments: 'Akses në departamentet',
    selectaccesstype: 'Zgjidh llojin e aksesit',
    accessread: 'Mund të shikojë',
    accesswrite: 'Mund të ndryshojë',
    isadmin: 'Është administrator'
  },

  alerts_employee_access: {
    nopackageselected: 'Duhet ta zgjidhni një pako',
    accessupdated: 'Aksesi i punonjësit u përditësua'
  },

  vacations_module: {
    print: 'Printo',
    vacationyear: 'Pushimi i vitit',
    vacationmonth: 'Pushimi i muajit',
    publicholidays: 'Pushimet Publike',
    nopublicholiday: 'Asnjë festë publike nuk u shtua',
    addnewholiday: 'Shtoni festë të re publike',
    editholiday: 'Redakto festën publike',
    edit: 'Redakto',
    delete: 'Fshije',
    createholiday: 'Krijoni një datë të re pushimi',
    createholidaysdsc:
      'Shkruaj emrin dhe datën e festës për të krijuar pushime të ri',
    holidayname: 'Emri i festës',
    holidaydate: 'Data e festës',

    right_to_use_next_year:
      "Ditët e mbetura të pushimeve mund t'i përdorin vitin e ardhshëm?",

    generalvac: 'Pushime të Përgjithshme',
    addnewvac: 'Shto pushime të ri',
    editvac: 'Redakto pushimet',
    createvacation: 'Krijoni pushime të ri',
    createvacationdsc:
      'Plotësoni fushat dhe krijoni pushime të ri për punonjësit tuaj',

    replacedby: 'Zevendesuar nga',
    vacationname: 'Emri i pushimeve',
    totaldays: 'Ditët totale',
    foryear: 'Për vitin',
    onetimetake: 'Merr një herë',
    extradays: 'Merrni ditë shtesë',
    year: 'Çdo vit',
    day: 'Çdo -- ditë',
    righttousemonth: 'E drejta për të përdorur muajin',
    righttouseyear: 'E drejta për përdorim',
    howcanuse: 'Kush mund ta përdorni këto pushime',
    hide: 'Fshih',
    roles: 'Rregulla',

    addvacation: 'Shto pushime',
    nogeneralvacations: 'Asnjë pushim i përgjithshëm nuk është shtuar',

    days: 'Dite',
    righttousenextyear: 'Mund të përdoret vitin e ardhshëm',

    manageempvacations: 'Menaxho Pushimet e Punonjësve',
    onvacation: 'Në pushim',
    pendingdepartmentleadapproval:
      'Në pritje për aprovim nga drejtuesi i departamentit',
    pendinghrapproval: 'Në pritje për aprovim nga HR',
    approved: 'Aprovimet',
    rejected: 'Refuzimet',
    requestdays: 'Ditët e kërkuara',
    requestedhalfdays: 'Ka kërkuar gjysmë dite',
    requestedhalfdaysam: 'Paradite',
    requestedhalfdayspm: 'Pasdite',
    vacationtype: 'Lloji i pushimit',
    reason: 'Arsyeja',
    decision: 'Pershkrimi',
    approvebtn: 'Aprovohet',
    rejectbtn: 'Refuzohet',
    nopendingdepartmentleadvacations:
      'Nuk ka pushime në pritje për aprovim nga udhëheqësi i departamentit',
    norejectedvacations: 'Nuk ka pushime të refuzuara',
    nopendinghrapprovalvacations: 'Nuk ka pushime në pritje për aprovim nga HR',
    noapprovedvacations: 'Nuk ka pushime të aprovuara',

    info: 'Info',

    general: 'gjenerale',
    employeespecific: 'specifike për këtë punëtor',

    rejectnotifycandidate: 'Lajmëro kandidatin për refuzimin',

    basevacation: 'Definicioni bazë',
    basevacationdc:
      'Jeni duke e ndryshuar pushimin për një punëtor specifik, ky pushim është i bazuar në',

    ispaid: 'Më pagesë',
    ispaidontermination: 'Paguhet në përfundim të kontratës',
    dailypaypercentage: 'Përqindja e pagës ditore'
  },

  alerts_vacations_module: {
    dateunique: 'Kjo datë ekziston tashmë si festë zyrtare',
    added: 'U shtua me sukses një pushime i ri publik',
    deleted: 'Festa publike u fshi me sukses',
    updated: 'Festa zyrtare e përditësua me sukses',

    smthwrong: 'Diçka shkoi keq, ju lutem provoni përsëri',

    addedvac: 'U shtua me sukses një pushim i ri i përgjithshëm',
    updvacation: 'Pushimi i përgjithshëm u përditësua me sukses',
    delvacation: 'U fshihen me sukses pushimi i përgjithshëm',

    approvedvacation: 'Kërkesa për pushime u aprovua me sukses',
    rejectedvacation: 'Kërkesa për pushime u refuzua me sukses',
    rejectreason: 'Ju lutemi shkruani më parë arsyen e refuzonit',
    deletedvacation: 'Kërkesa për pushime u fshi me sukses'
  },

  payment_settings: {
    paymentsettings: 'Cilësimet e Pagesës',
    packages: 'Paketat',
    availablemodules: 'Modulet në dispozicion',
    activemodules: 'Modulet Aktive',
    invoices: 'Faturat',
    activemodulesdsc: 'Lista e moduleve që po përdorni aktualisht',
    noactivemodules: 'Asnjë modul aktiv për kompaninë tuaj',
    'euro-peremployee': '€ / për punonjës',
    availablemodulesdsc:
      "Lista e moduleve që janë në dispozicion dhe ju mund t'i përdorni ato",
    addmodule: 'Shto modulin',
    allmodulesasigned:
      'Të gjithë modulet Hrbee janë aktivizuar për kompaninë / institucionin tuaj',

    invoiceno: 'Numri i faturës',
    paymentmethod: 'Metoda e pagesës',
    amount: 'Shuma për pages',
    details: 'Detajet',
    noinvoice: 'Ju nuk keni ndonjë faturë ende'
  },

  'payment_settings-alerts': {
    packagerequestsent: 'Kërkesa për pako është dërguar'
  },

  account_settings: {
    rate_by: 'Section should be rated from',
    rate_frequency: 'Frekuenca e vlerësimit',
    staff_category: 'Kategoria e Stafit',
    pay_tax: 'Pagesa e taksave',
    pay_tax_short: 'Taksat',
    pay_contribution: 'Pagesa e kontributeve',
    pay_contribution_short: 'Kontributet',
    job_description: 'Përshkkrimi i punës',
    belongstodepartment: 'I përket departamentit',
    belongstosubdepartment: 'I përket nëndepartamentit',

    api: 'API',
    apidsc: 'Gjeneroni çelësin tuaj API dhe përdorni disa nga pikat fundore',
    apigeneratebutton: 'Gjeneroni çelësin API',
    apiGetEmployees: 'Përdorni këtë API për të marrë listën e punonjësve tuaj',
    apiGetVacations: 'Përdorni këtë URL për të marrë listën e pushimeve',
    apiGetPerformances: 'Përdorni këtë URL për të marrë listën e performancave',

    accountsettings: 'Cilësimet e llogarisë',
    businessinfo: 'Informacione afariste',
    businessinfodsc:
      'Ndryshoni detajet kryesore të informacionit të kompanisë tuaj më poshtë',
    mainpayrollcurrency: 'Valuta kryesore e pagave',
    selectmainpayrollcurrency: 'Zgjidhni valutën e kompanisë',
    mainpayrollcurrencyhelp:
      'Kjo valutë përdoret si bazë për gjenerimin e pagave dhe raportimin.',
    mainpayrollcurrencyrequired:
      'Valuta kryesore e pagave është e detyrueshme.',
    businesslogo: 'Logo e biznesit',
    businesslogodsc: 'Më poshtë mund të ngarkoni logon e biznesit tua',
    businesspassword: 'Fjalëkalimi i biznesit',
    businessdresscode: 'Kodi i Veshjes së Biznesit',
    businessregulation: 'Rregullorja e biznesit',
    businessorganogram: 'Organogrami i biznesit',
    generalsettings: 'Cilësimet e përgjithshme',
    integrations: 'Integrimet',
    integrationsaccesscontrol: 'Integrimi i kontrollimit të hyrjeve/daljeve',
    integrationsaccesscontroldc:
      'Lidh API-në tuaj për kontrollimin e hyrjeve dhe daljeve të punonjësve',
    integrationsaccesscontroldocumentation: 'Shiko dokumentimin e API',
    integrationsauthtype: 'Lloji i vërtetimit',
    integrationsauthendpoint: 'Endpoint për vërtetim',
    integrationsauthusername: 'Emri i përdoruesit për vërtetim',
    integrationsauthpassword: 'Fjalëkalimi për vërtetim',
    integrationsauthtoken: 'Token-i për vërtetim',
    integrationsapiendpoint: 'API endpoint',
    localedc:
      'Ky cilësim do të përcaktojë se në cilën gjuhë do të jenë emailet e dërguara punonjësve tuaj',
    employeeaccesses: 'Qasjet e punonjësve',
    attachcertificate: 'Bashkangjit Certifikatën',
    editattachcertificate: 'Ndrysho Certifikatën',
    seecertificate: 'Shiko Certifikatën',
    save: 'Ruaj',
    attachbusinesscertificate: 'Bashkangjit Certifikatën e Biznesit',
    addbusinessregulation: 'Shto rregullore',
    addbusinessregulationinfo: 'Bashkangjit rregulloret e biznesit',

    profilelogo: 'Logoja e profilit',
    businesscategorylogo: 'Logoja e kategorisë së biznesit',
    changelogo: 'Ndrysho logon',
    uploadlogo: 'Ngarko logon',

    fileaccepted: 'File u pranua: ',
    maxfile: 'Madhësia max e file: ',

    changepassword: 'Ndrysho fjalekalimin',
    changepassworddsc:
      'Nëse keni nevojë të ndryshoni fjalëkalimin e llogarisë tuaj, mund ta bëni këtu',
    currentpassword: 'Fjalëkalimi aktual',

    createdepartment: 'Krijoni departamentin',
    createposition: 'Krijoni pozicion',

    departmentname: 'Emri i Departamentit',
    departmentclass: 'Klasa e departamentit',
    reportto: 'Raporto tek',
    adddepartment: 'Shto departamentin',

    positionname: 'Emri i poztës',
    choosedepartment: 'Zgjidhni Departamentin',
    choosesubdepartment: 'Zgjidhni Nën Departamentin',
    addposition: 'Shto pozicionin',
    addsubdepartment: 'Shto nën departament',
    addsubsubdepartment: 'Shto nën nën departament',

    edit: 'Redakto',
    delete: 'Fshije',

    noposition: 'Nuk ka asnjë pozitë të krijuar në këtë departament',

    updatedepartment: 'Përditëso departamentin',
    updateposition: 'Përditëso pozitën',

    uploaddresscode: 'Ngarko kodin e veshjes së biznesit tuaj',
    adddresscode: 'Shto kod të ri të veshjes',
    back: 'Prapa',
    nodresscode: 'Asnjë kod veshjeje',
    nodresscodedsc:
      'Shkoni për të shtuar kodin e ri të veshjes dhe krijoni kodin e veshjes për kompaninë tuaj',

    employeestatistics: 'Statistikat e punëtorëve',
    employeereports: 'Raportet e puntorëve',
    employeereportsdc:
      'Gjenero një excel file që përmban të dhënat e të gjithë puntorëve të kompanisë',

    expiredcontract: 'Punëtorët me kontratë të skaduar',
    employeecontracts30: 'Kontratat e punëtorëve që mbarojnë mbrenda 30 ditë',
    employeecontracts60: 'Kontratat e punëtorëve që mbarojnë mbrenda 60 ditë',
    employeecontracts_intern_7:
      'Kontratat e praktikës që mbarojnë brenda 7 ditë',
    employeecontracts_intern_15:
      'Kontratat e praktikës që mbarojnë brenda 15 ditë',
    employeecontracts_all_normal: 'Të gjitha kontratat normale',
    employeecontracts_all_interns: 'Të gjitha kontratat e praktikës',
    employeecontracts_probation_7:
      'Kontratat në periudhë provuese që mbarojnë brenda 7 ditë',
    employeecontracts_probation_16:
      'Kontratat në periudhë provuese që mbarojnë brenda 16 ditë',
    employeecontracts_all: 'Të gjitha kontratat e punëtorëve',
    nodatafound: 'Nuk ka të dhëna',

    employeeleavereports: 'Raportet e pushimeve',
    employeeleavereportsdc:
      'Gjenero një excel file që përmban të dhënat e të gjitha pushimeve të puntorëve të kompanisë',

    employeepromotionsreports: 'Raportet e ngritjeve në pozitë',
    employeepromotionsreportsdc:
      'Gjenero një excel file që përmban të dhënat e të gjitha ngritjeve në pozitë të puntorëve të kompanisë',

    recruitmentreports: 'Raportet e rekrutimit',
    recruitmentreportsdc:
      'Gjenero një excel file që përmban statistika të rekrutimit',

    downloadreport: 'Shkarko raportin',
    downloadreportall: 'Shkarko raportin e plotë',
    downloadleavesreport: 'Shkarko raportin e pushimeve',
    downloadunusedleavesreport: 'Shkarko raporting e pushimeve të papërdorura',

    noexpiringcontracts:
      'Nuk ka kontrata të cilat skadojnë në 60 ditët e ardhshme',

    email_for_wages:
      'Dëshironi që punonjësi juaj të marrë email kur krijohen pagat?',
    email_for_wages_info:
      'Ky cilësim do të përcaktojë nëse punonjësit tuaj do të marrin email kur të krijohen pagat',
    language_employee_emails: 'Zgjidhni gjuhën për emailet e punonjësve',
    email_for_birthdays:
      'Dëshironi që punonjësi juaj të marrë email për ditëlindje?',
    email_for_birthday_info:
      'Ky cilësim do të përcaktojë nëse punonjësit tuaj do të marrin email për ditëlindje. Emaili do të dërgohet nga HrBee në emër të kompanisë suaj',
    email_for_work_anniversary:
      'Dëshironi që punonjësi juaj të marrë email për përvjetorin e punës?',
    email_for_work_anniversary_info:
      'Ky cilësim do të përcaktojë nëse punonjësit tuaj do të marrin email për përvjetorin e punës. Emaili do të dërgohet nga HrBee në emër të kompanisë suaj',
    anniversary_email_content: 'Përmbajtja e emailit për përvjetorin e punës',
    vacation_weekend_count: 'Lejoni pushimet në fundjavë',
    vacation_weekend_count_info:
      'Ky cilësim do të përcaktojë cilësimet e pushimeve',
    contracts_notification_and_read:
      'Lejo punonjësin të shënojë rregulloret si të lexuara',
    contracts_notification_and_read_info:
      'Ky cilësim do të përcaktojë nëse dëshironi të lejoni punonjësit të shënojnë rregulloret si të lexuara'
  },

  'account_settings-alerts': {
    attachedfile: 'Certifikata e biznesit u bashkëngjit me sukses',
    somethingwentwrong: 'Diçka shkoi keq, ju lutem provoni përsëri',
    companyinfoupdated: 'Informacioni i kompanisë u përitësua me sukses',
    fillrequiredfields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara',

    maxfileerror:
      'Madhësia maksimale e file është 5 MB, ju lutemi zgjidhni një file tjetër',
    logosaved: 'Logoja u ngarkua me sukses',
    noimage: 'Asnjë imazh i zgjedhur, ju lutemi zgjidhni një imazh',
    passwordchanged: 'Fjalëkalimi i llogarisë tuaj ndryshoi me sukses',
    regulationupdated: 'Rregullorja e biznesit përditësua me sukses',
    regulationsaved: 'Rregullorja biznesit u ruajt me sukses',
    dresscodesaved: 'Kodi i ri i veshjes së biznesit u shtua me sukses',
    departmentsuccess: 'Departamenti u shtua me sukses',
    subdepartmentsuccess: 'Nën departamenti u shtua me sukses',
    subsubdepartmentsuccess: 'Nën nën departamenti u shtua me sukses',
    positionsuccess: 'Pozita u shtua me sukses',

    departmentupdated: 'Departamenti u përditësua me sukses',
    subdepartmentupdated: 'Nën departamenti u përditësua me sukses',
    positionupdated: 'Pozita u përditësua me sukses',
    trytodelete:
      'Ju nuk mund ta fshini këtë departament derisa ekziston pozicion në këtë departament',
    deletedepartment: 'Departamenti u fshi me sukses',
    deleteposition: 'Pozita u fshi me sukses',
    deletedresscode: 'Kodi i veshjes u fshi me sukses'
  },

  feeds_module: {
    cancelfilters: 'Anulo',
    comingsoon: 'Vjen së shpejti',

    birthdaymonth: 'Muaji i Ditalindjes',
    choosebirthday: 'Zgjidhni Ditëlindjen',
    noemployeebasedonthisfilter: 'Asnjë punonjës i bazuar në këtë filtër',
    chooseposition: 'Zgjidhni pozitën',
    email: 'E-mail',
    mobile: 'Mobile',

    createevent: 'Krijo ngjarje',
    createeventdsc: "Krijoni një ngjarje që do t'i shfaqet punonjësit tuaj",
    date: 'Data',
    location: 'Lokacioni',
    invited: 'Te ftuar',
    note: 'Shënime',
    postevent: ' Posto ngjarjen ',
    editevent: 'Redakto ngjarjen',
    updateevent: 'Përditëso ngjarjen',
    cancel: 'Anulo',
    edit: 'Redakto',
    delete: 'Fshije',
    noevents: 'Asnjë Ngjarje',

    share: 'Shpërndaje',
    addlink: 'Shto Link',
    image: 'Imazh',
    paragraph: 'Paragraf',
    deletepost: 'Fshije Postimin',
    nofeeds: 'Ende nuk ka njoftime të publikuara',

    organogramofcompany: 'Organogrami',
    dresscode: 'Kodi i veshjes',
    regulations: 'Rregullorja',
    contacts: 'Kontaktet',
    events: 'Ngjarjet',
    birthdays: 'Ditëlindjet',
    chat: 'Çeti',

    hrdepartment: 'Burimet njerëzore të këtij departamenti',
    hrdepartmentdsc:
      'Përgatitja e listës tuaj të punonjësve përmes departamentit të zgjedhur',
    noemployeeinthisdepartment: 'Nuk ka asnjë punonjës në këtë departament',

    feedpermissions: 'Autorizimet për ngjarjet',
    editfeedpermissions: 'Kush mund të postoj ngjarje?',
    editfeedpermissionsbtn: 'Ndrysho autorizimet për ngjarjet',

    sharedwithdepartments: 'E ndarë me departamentet'
  },

  'feeds_module-alerts': {
    somethingwentwrong: 'Diçka shkoi keq, ju lutem provoni përsëri',
    deleteevent: 'Ngjarja u fshi me sukses',
    updateevent: 'Ngjarja u përditësua me sukses',
    requiredfields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara',
    addevent: 'Ngjarja u shtua me sukses',

    typesomething: 'Ju lutemi shkruani diçka së pari',
    addpost: 'Postimi u shtua me sukses',
    deletepost: 'Postimi u fshi me sukses'
  },

  monthsvalue: {
    1: 'Janar',
    2: 'Shkurt',
    3: 'Mars',
    4: 'Prill',
    5: 'Maj',
    6: 'Qershor',
    7: 'Korrik',
    8: 'Gusht',
    9: 'Shtator',
    10: 'Tetor',
    11: 'Nëntori',
    12: 'Dhjetor'
  },

  insurance_module: {
    employees_insurances: 'Sigurimet e punëtorëve',
    employees_insurances_description:
      'Më poshtë mund të gjeni të gjithë punonjësit tuaj, mund të zgjidhni një prej tyre dhe të menaxhoni të dhënat e sigurimit',
    noemployeefound:
      'Nuk u gjet asnjë punëtor, ju lutemi shkoni tek moduli i punëtorëve dhe regjistroni punëtorët tuaj',
    for_employee: 'Për punëtorin',
    insurances_for_employee_not_found: 'Nuk ka të dhëna',
    full_name: 'Emri i plotë',
    total_insurance: 'Sigurimi total',
    company_insurance: 'Pagesa nga kompania',
    employee_insurance: 'Pagesa nga punëtori',
    relation: 'Marrëdhëniet',
    for_employee_ralations: 'Për marrëdhëniet me punonjësit',
    insurances_for_employee_relations_not_found: 'Nuk ka të dhëna'
  },

  wages_module: {
    deletegeneratedwages: 'Fshij pagat e gjeneruara',
    grosssalaryByHours: 'Paga bruto sipas oreve',
    export_language: 'Selekto gjuhën',
    description: 'Përshkrimi',
    primaryjob: 'Puna primare',
    secondaryjob: 'Punë dytësore',
    joindate: 'Fillimi i punës',
    settingsfinances: 'Cilësimet e pagave për kompaninë tuaj',
    'tax0-80': 'Tax 0-250',
    'tax80-250': 'Tax 0-250',
    'tax250-450': 'Tax 250-450',
    'tax>450': 'Tax > 450',
    contribution: 'Kontributi',
    overtime: 'Jashtë orarit',
    wardship: 'Kujdestari',
    weekendholidays: 'Pushimet e fundjavës',
    savefinancialsettings: 'Ruaj cilësimet e pagave',

    addemptowageslist: 'Shtoni punonjës të ri në listën e pagave',
    back: 'Prapa',
    empwageslist: 'Lista e pagave të punonjësve',
    empwageslistdsc:
      'Më poshtë ju mund të gjeni listën e punonjësve që janë shtuar në listën e pagave',
    edit: 'Redakto',
    delete: 'Fshije',
    noempinwageslist:
      'Nuk ka punonjës në listën e pagave, ju lutem shtoni re tani',

    generatewages: 'Gjeneroni pagat',
    taxdeclaration: 'Deklarimi i taksave',
    export: 'Eksport',
    salaryfor: 'Pagat për',
    bonusfor: 'Bonuset për',
    grosssalary: 'Paga bruto',
    totalsalary: 'Paga totale',
    healthinsurancecost: 'Sigurimi bruto',
    healthinsurancecostneto: 'Sigurimi neto',
    rankofjob: 'Rangu i punës',
    absencededuction: 'Heqje për mungesat',
    leavededuction: 'Heqje për pushime',
    totaltax: 'Taksa totale',
    netsalary: 'Paga Neto',
    nowagesgenerated: 'Nuk ka paga të gjeneruara',
    nobonuses: 'Nuk ka bonuse',
    generatemonthly: 'Gjeneroni pagat mujore të punonjësve',
    selectyear: 'Zgjedhin vitin',
    selectmonth: 'Zgjidhni muajin',
    editwages: 'Redakto pagën e punonjësit të zgjedhur',
    editbonusof: 'Redakto bonusin e',
    advancepayment: 'Paradhënie',
    leavewithoutpayment: 'Pushime pa pagesë',
    bonuspayment: 'Pagesa e bonusit',
    mealspayment: 'Pagesa e shujtave',
    workinghours: 'Orë pune',
    workhourspermonth: 'Orët e punës në muaj',
    priceperhour: 'Çmimi në orë',
    grosssalarybyhours: 'Paga bruto sipas orëve',
    'overtime-nightshift': 'Koha shtesë - ndërrimi i natës',
    save: 'Ruaj',

    filter: 'Filtro',
    clearfilter: 'Pastro Filtrimet',
    filterwages: 'Filtro pagat sipas vitit dhe muajit',
    closeallwages: 'Mbyll pagat',
    no_salaries_available_for_period: 'Nuk ka paga për {month} të vitit {year}',

    salarybonus: 'Bonus',
    grosssalarybonus: 'Bonus bruto',
    grosssalarytotal: 'Rroga totale bruto',
    bonusnote: 'Shënimi i bonusit',
    salaryincrements: 'Rritje rroge',
    incrementsalaryeverynyears: 'Rritje rroge çdo',
    basesalary: 'Rroga bazë bruto',
    incrementsalarybyamount: 'Sasia e rritjes',
    salaryincrementedbyvalue: 'Sasia e rritjes së tanishme',
    years: 'vit(e)',
    onmonth: 'Në muajin',

    extra: 'Ekstra',

    closed: 'E mbyllur',

    uploadbonuses: 'Ngarko bonuset',
    deletebonuses: 'Fshi bonuset',

    selectbonusexcel: 'Zgjidh dokumentin Microsoft Excel për të ngarkuar'
  },

  'wages_module-alerts': {
    somethingwentwrong: 'Diçka shkoi keq, ju lutem provoni përsëri',
    settingsupdated: 'Cilësimet e pagave u përditësua me sukses',
    deletefromwageslist: 'Punonjësi u fshi nga lista e pagave',

    wagedelete: 'Paga u fshi me sukses',
    wageupdated: 'Paga u përditësua me sukses',
    wagesgenerated: 'Pagat u gjeneruaran me sukses',
    alredygenerated: 'Pagat veq se janë të gjeneruara për këtë muaj'
  },

  noaccesspages: {
    nopackage: 'Ju nuk keni akses në këtë paketë',
    nopackagedsc:
      'Nëse dëshironi të keni akses, ju duhet të aktivizoni këtë paketë',
    viewpackages: 'Shiko paketat',

    noaccesstopage: 'Ju nuk keni akses në këtë faqe',
    noaccesstopagedsc:
      'Nëse dëshironi të keni akses ju duhet të aktivizoni llogarinë tuaj përmes e-mailit'
  },
  aboutus_page: {
    aboutus: 'Për Ne',
    aboutusdsc1:
      'Ne jemi të fokusuar në ofrimin e shërbimeve të cilat ju ndihmojnë kompanive që ta rrisin profitin e tyre duke menaxhuard performancën e stafit të tyre.',
    aboutusdsc2:
      'Digjitalizimi i proceseve për menaxhimin e burimeve njerzore është shumë i rëndësishëm për arritjen e sukseseve dhe zhvillimin e ndërmarrjeve.',
    aboutusdsc3:
      'Andaj përmes platformës Hr bee Management, ndërmarrësit do të mund që të menaxhojnë punonjësit përmes disa moduleve të cilat platforma i ofron.',
    aboutusdsc4: 'Janë më shumë se 320 + procese plotësisht të dixhitalizuara.',
    aboutusdsc5:
      'Duke njohur kapacitetet e burimeve njerëzore që ndërmarrjet kanë, do ta kenë më të lehtë që të menaxhojnë edhe të planifikojnë resurset e nevojshme në arritjen e qëllimeve që ndërmarrjet i kanë vënë vetes.',
    aboutusdsc:
      'Duke punuar në zyrën e burimeve njerëzore dhe duke parë që shumica e kohës po merrej me proceset teknike të përditshme..... Ai ndaloi për një moment dhe filloi të mendonte! Duhet të keni një zgjedhje? Po sikur të isha si një bletë? Po, një bletë që pavarësisht se ka një numër të madh të punëtorëve bën gjithçka më së miri. Aty filloj gjithçka për të vazhduar fillimisht si një rast studimi brenda Kosovës për tu zhvilluar më tej në Rajon dhe pastaj drejt Evropës. … Po, ne kemi ndërtuar bletë dixhitale për të ndihmuar secilin prej jush të menaxhojë punonjësit dhe të ketë kohë për procese të rëndësishme strategjike për kompaninë e tyre. Bleta dixhitale.',

    ourteam: 'Ekipa jonë',
    ourteamdsc1: 'Ekipa e Hr bee Management është e përbërë nga këto fusha:',
    ourteamdsc2:
      'Menaxhmenti, Burimet Njerëzore, Juridiku dhe Teknologjia Informative',
    ourteamdsc3: 'Me një eksperiencë mesatare pune mbi',
    ourteamdsc4: '18+ vite',
    ourteamdsc:
      'Digjitalizimi i proceseve për menaxhimin e burimeve njerzore është shumë i rëndësishëm për arritjen e sukseve dhe zhvillin e ndërmarrjeve Andaj përmes platformës hr bee, ndërmarrësit do të mund që të menaxhojnë punonjësit përmes disa moduleve të cilat platforma i ofron. Duke njohur kapacitetet e burimeve njerzore që ndërmarrjet kanë, do ta kenë më të lehtë që të menaxhojnë edhe të planifikojnë resurset e nevojshme në arritjen e qëllimeve që ndërmarrjet i kanë vënë vehtës.',

    ourpartners: 'Partneret tanë',
    ourpartnersdsc:
      'Disa nga partnerët tanë në vende të ndryshme që operojnë...',

    ourclients: 'Klientët tanë',
    ourclientsdsc: 'Disa nga klientët tanë që përdorin Hrbee',

    weoperatein: 'Ne operojme në!',
    weoperateindsc1: 'Aktualisht ne jemi duke operuar në Kosovë dhe Shqipëri',
    weoperateindsc2:
      'Ne gjithashtu jemi duke punuar për lansimin e platformës ne Europë',
    weoperateindsc3: 'Nëse dëshironi të jeni partneri jonë ne vendin tuaj',
    clickhere: 'klikoni këtu',

    contactus: 'Na kontaktoni',
    contactusdsc1:
      'Mos ngurroni të na kontaktoni për çdo pyetje ose shqetësim që mund të keni.',
    contactusdsc2:
      'Gjithmonë të lumtur për të komunikuar me ju. Na dërgoni një mesazh,',

    sendmsgbtn: 'Dërgoni mesazh',

    address: 'Adresa',
    mainoffice: 'Adresa kryesore',
    information: 'Informacioni',
    support: 'Mbështetja',
    franchizes: 'Franshiza'
  },
  product_page: {
    featuresbtn: 'Karakteristikat',
    createaccountbtn: 'Krijo llogarinë',
    backbtn: 'Prapa',

    company: 'Kompanitë',
    companydsc:
      'Dixhitalizimi i proceseve të menaxhimit të burimeve njerëzore është shumë i rëndësishëm për arritjen e suksesit dhe zhvillimin e ndërmarrjeve. Prandaj përmes platformës hr bee, kompanitë do të jenë në gjendje të menaxhojnë punonjësit përmes disa prej moduleve që ofron platforma.',
    companydsc1:
      'Duke njohur kapacitetet e burimeve njerëzore që kanë ndërmarrjet, do të jetë më e lehtë për ta që të menaxhojnë dhe planifikojnë burimet e nevojshme në arritjen e qëllimeve që ndërmarrjet i kanë vendosur vetes.',

    jobseeker: 'Punë kërkuesit',
    jobseekerdsc1:
      'Gjetja e një pune sot është shumë e vështirë dhe ndonjëherë duket pothuajse e pamundur.',
    jobseekerdsc2:
      'Dixhitalizimi sot është një mjet shumë i rëndësishëm për të gjetur atë punë.',
    jobseekerdsc3:
      'Prandaj, duke dixhitalizuar profilin e punëkërkuesit, së pari krijoni një standard për profilin tuaj, i cili është i rëndësishëm për procesin e mëtejshëm të aplikimit për punë. Ju duhet të futni të dhënat tuaja vetëm një herë në sistem dhe më pas të aplikoni për punë të ndryshme me vetëm një klikim.',

    signupandcreatecv: 'Regjistrohuni dhe krijoni CV-në tuaj',
    signupandcreatecvdsc1:
      'Për të aplikuar për punë duhet të keni një llogari të punëkërkuesit në HRBEE.',
    signupandcreatecvdsc2:
      'Sa më shpejt që ju të regjistroheni ju do të keni mundësi për të krijuar CV tuaj online, si dhe për ta shkarkuar atë në një template që kemi përgatitur.',

    findjobandapply: 'Gjeni punë dhe aplikoni',
    findjobandapplydsc1:
      'Hr Bee lehtëson procesin e kërkimit të punës për punëkërkuesit.',
    findjobandapplydsc2:
      'Dhe kjo u mundëson atyre që të aplikojnë për vendet e lira të punës me vetëm një klikim ose duke e ruajtur atë punë për të aplikuar më vonë.',

    wekeepupdated: 'Ne të ju mbajë të përditësuar në lidhje me aplikimin tuaj',
    wekeepupdateddsc1:
      'Hrbee i mundëson punëkërkuesit për të bashkëvepruar me kompanitë per poziten që keni aplikuar ai/ajo.',
    wekeepupdateddsc2:
      "Kjo përfshin njoftime në lidhje me aplikimin tuaj të punës. Ju do të merrni njoftime për t'u ftuar në intervistë, njoftime edhe kur aplikimi juaj refuzohet dhe madje edhe nëse kualifikoheni për t'u bërë punonjës te asaj kompanije, do të keni llogarinë tuaj si një punonjës.",

    feedmodule: 'Moduli i njoftimeve',
    feedmoduledsc:
      'Moduli i njoftimeve lehtëson komunikimin përbrenda kompanisë në mes jush dhe punonjesve tuaj në kohë reale',
    feedmodule1: 'Nderveprini me punonjësit',
    feedmodule2: 'Bashkëveproni me punonjësit tuaj brenda kompanisë',
    feedmodule3:
      'Komunikimi dhe ndërveprimi midis punonjësve brenda ndërmarrjes ka një rëndësi të veçantë. Përmes këtij moduli ju mund të shpërndani informacion të rëndësishëm për punonjësit tuaj duke ruajtur privatësinë e këtij informacioni',

    recruitmentmodule: 'Moduli i rekrutimit',
    recruitmentmoduledsc:
      'Moduli i rekrutimit lehtëson procesin e rekrutimit dhe ju ndihmon të bëni zgjedhjen tuaj të stafit sipas kritereve që keni zgjedhur. Përmes këtij moduli, procesi i rekrutimit do të jetë më i lehtë, më efikas dhe 100% më i shpejtë se më parë',
    recruitmentmodule1: 'KRIJIMI I KONKURSIT',
    recruitmentmodule2:
      'Krijoni dhe menaxhoni aplikacioneve për vendet e lira të punës të kompanisë suaj',
    recruitmentmodule3:
      'Përmes modulit te rekrutimit procesi i krijimin / shpalljes së një vendi të lirë pune dhe menaxhimi i tij do të jetë shumë më i thjeshtë. Thjesht duhet të plotësoni fushat e standartizuara që i kerkohen dhe njoftimi juaj do të publikohet. Gjithashtu ekziston edhe shablloni per pershkrimin e konkursit tuaj',
    recruitmentmodule4: 'INTERVISTA',
    recruitmentmodule5: 'Përzgjidhni dhe ftoni kandidatët për intervistë',
    recruitmentmodule6:
      'Përzgjedhja e një kandidati për intervistë do te jete shume me e lehte dhe me e thjesht. Pas vlersimit te CV se kandidatit ju mund qe ti dergoni ftesen per intervistim, thjesht duhet të përcaktoni: ditën, kohën e intervistës kandidati dhe kandidati automatikisht do të marrin njoftimin e intervistës nga ana juaj',
    recruitmentmodule7: 'VLERSIMET',
    recruitmentmodule8: 'Vlerësoni kandidatët bazuar në kriteret e pozitës',
    recruitmentmodule9:
      "Vlerësimi i kandidatëve gjatë intervistës është gjithashtu një element shumë i rëndësishëm dhe do t'ju ndihmojë në fund të procesit ta bëni më të qartë dhe më të lehtë zgjedhjen e kandidatit më të suksesshëm për atë punë",

    employeesmodule: 'Moduli i punonjësve',
    employeesmoduledsc:
      'Një kompani nuk mund të zhvillohet pa menaxhimin e duhur të burimeve njerëzore. Menaxhimi i burimeve njerëzore përfshin në vete shumë procese të cilat ne i kemi përfshirë në këtë modul',
    employeesmodule1: 'PUNONJËSIT',
    employeesmodule2: 'Menaxho punonjësit',
    employeesmodule3:
      'Menaxhoni të gjitha proceset e burimeve njerëzore në mënyrë dixhitale dhe interaktive me punonjësit e kompanisë',
    employeesmodule4: 'DOKUMENTE',
    employeesmodule5: 'Menaxhoni dokumentet e secilit punonjës',
    employeesmodule6:
      'Të gjitha dokumentet / dosjet e personelit do të arkivohen në mënyrë dixhitale për kë individ veçmas',
    employeesmodule7: 'DETAJE PUNE',
    employeesmodule8: 'Menaxhoni historikun e punës së punonjësve',
    employeesmodule9:
      'Historia e zhvillimit të çdo punonjësi do të ruhet në mënyrë dixhitale dhe e qasshme për të dy palët',
    employeesmodule10: 'PUNËSIMI I PUNONJËSVE',
    employeesmodule11: 'Regjistrimi i punonjësve',
    employeesmodule12:
      'Regjistrimi i punonjësve mund të bëhet përmes modulit të rekrutimit ose duke regjistruar manualisht punonjësin në kompani',

    workingschedule: 'Moduli i orarit të punës',
    workingscheduledsc:
      'Menaxhimi i orareve dhe vendosja e stafit në vend dhe koha e duhur ka një rëndësi të madhe në zhvillimin e proceseve brenda ndërmarrjes',
    workingschedule1: 'RREGULLIMET E ORARIT TË PUNËS',
    workingschedule2: 'Krijimi i orareve dhe ndrrimeve per punonjesit',
    workingschedule3:
      'Menaxhimi dhe planifikimi i orëve të punës për punonjësit ka një rëndësi të veçantë për proceset e përditshme brenda kompanisë',
    workingschedule4: 'ORARI I PUNES',
    workingschedule5: 'Menaxhoni orarin e punës së punonjësve',
    workingschedule6:
      'Orari i punës mund të menaxhohet sipas departamentet apo sipas punonjësit brenda departamenteve',

    vacationmodule: 'Moduli i pushimeve',
    vacationmoduledsc:
      'Moduli i pushimeve ju ndihmojnë të menaxhoni dhe akordoni pushimet e stafit tuaj me aktivitetet e kompanisë suaj',
    vacationmodule1: 'RREGULLAT E PUSHIMEVE',
    vacationmodule2: 'Krijoni dhe menaxhoni llojet e pushimeve',
    vacationmodule3:
      'Përcaktoni llojet dhe ditët e pushimeve sipas specifikimeve të kompanisë',
    vacationmodule4: 'RREGULLAT E PUSHIMEVE',
    vacationmodule5: 'Përcaktoni festat publike',
    vacationmodule6:
      'Përcaktoni festat zyrtare sipas vendeve dhe besimeve fetare',
    vacationmodule7: 'KËRKESAT PËR PUSHIME',
    vacationmodule8: 'Menaxhimi i kerkesave per pushime',
    vacationmodule9:
      'Ju mund të menaxhoni kërkesate e punonjesve tuaja për pushime sipas prioriteteve që ata mund ti kenë',
    vacationmodule10: 'LEJAT E PUSHIMEVE',
    vacationmodule11: 'Kontrollo listen e pushimeve te aprovuara / refuzuara',
    vacationmodule12:
      'Ju mund të shihni ditët e pushimeve për të cilët punonjësit sipas llojeve të pushimeve',

    wagesmodule: 'Moduli i pagave',
    wagesmoduledsc:
      'Ky modul ju lehtëson llogaritjen dhe gjenerimin e të gjithë procesimit të pagesave për punonjësit tuaj.',
    wagesmodule1: 'RREGULLAT E PAGAVE',
    wagesmodule2: 'Generation dhe përditësimin e pagës së punonjësve',
    wagesmodule3: 'Gjenerimi dhe përditesimi i pagës e punonjësit',
    wagesmodule4: 'RREGULLAT E PAGAVE',
    wagesmodule5: 'Shikoni pagat e gjeneruara te profilit i punonjësve',
    wagesmodule6:
      'Gjenerimi i listave të pagave mujore në profilet e punonjësve dhe lejimi i punonjësve të shohin llogaritjet e pagave të tyre',
    wagesmodule7: 'RREGULLAT E PAGAVE',
    wagesmodule8:
      'Llogaritja dhe gjenerimi i listës së pagave bëhet në vetëm tre hapa',
    wagesmodule9:
      'Ju duhet të caktoni vit dhe muajin për të cilin dëshironi të gjeneroni dhe të gjitha kalkulimete bëhen automatikisht',
    wagesmodule10: 'PAGAT',
    wagesmodule11: 'Shtoni punonjës në listën e pagave',
    wagesmodule12:
      'Shtimi ose heqja nga lista e pagave është shumë i lehtë dhe e thjeshtë',

    onboardmodule: 'Moduli onboard',
    trainingmodule: 'Moduli i trajnimeve',
    insurancemodule: 'Moduli i sigurimeve shëndetsore',
    performancemodule: 'Moduli i performancës',
    underconstruction: '>>> Duke u zhvilluar - 45% i zhvilluar',

    createaccountasjobseeker: 'Krijo llogari si punëkërkues',
    fillyourresume: 'Plotëso CV-në tuaj',
    vacancyapply: 'Si të aplikosh për punë',
    acceptinvitationforinterview: 'Prano ftesa për intervistë',

    features: 'Features'
  },
  auth_page: {
    jobseeker: 'PUNË KËRKUES',
    company: 'KOMPANI'
  },
  footer: {
    footerdescription:
      '**HR bee Management** është një softuer për Menaxhimin e Burimeve Njerëzore i bazuar në cloud, që u mundëson kompanive të menaxhojnë punonjësit e tyre dhe ndihmon kërkuesit e punës të gjejnë punën e tyre të ëndrrave. Të dy palët mund të kërkojnë, lidhen dhe kontraktojnë pa pengesa.',

    product: 'Produkti',
    jobseeker: 'Punë kërkues',
    pricing: 'Çmimet',
    knowledgebase: 'Njohuri bazike',
    downloadapp: 'Shkarko aplikacionin',
    partnerprogram: 'Programi për partner',
    api: 'API',

    company: 'Kompania',
    aboutus: 'Rreth nesh',
    clients: 'Klientët',
    partners: 'Partnerët',
    whereweare: 'Ku gjindemi?',
    contactus: 'Na kontaktoni',
    support: 'Mbështetje',

    allrightreserved: 'Të drejtat © 2026 HR bee Management',
    privacypolicy: 'Privatësia & Politikat',
    termsconditions: 'Termet & Kushtet'
  },
  header_page: {
    editimage: 'Ndrysho imazhin',
    insertimage: 'Shto imazh',
    namesurname: 'Emri & Mbiemri',
    title: 'Titulli',
    birthday: 'Datëlindja',
    country: 'Shteti',
    city: 'Qyteti',
    nationalID: 'ID shtetërore',
    profileID: 'ID profilit',
    shortbio: 'Biografi e shkurtër',
    socialmedia: 'Rrjetet sociale:',

    add: 'Shto',
    edit: 'Ndrysho',
    addnow: 'Shto tani'
  },

  notifications_page: {
    no_notifications: 'Nuk keni njoftime të reja',
    all_notifications: 'Njoftimet',
    mark_all_as_read: 'Shënoji si të lexuara'
  },

  navigationlinks: {
    training: 'Akademia e BNj',
    downloadcv: 'Shkarko CV',
    product: 'Produkti',
    pricing: 'Çmimet',
    aboutus: 'Rreth nesh',
    demo: 'Demo',
    login: 'Kyqu',
    logout: 'Ç`kyçu',
    editcv: 'Ndrysho CV',
    dashboard: 'Dashboard',
    language: 'Gjuha',
    newfeeds: 'New Feeds',
    vacations: 'Pushimet',
    salaries: 'Financat',
    schedules: 'Oraret',
    events: 'Eventet',
    organogram: 'Organogrami',
    dresscode: 'Kodi i veshjes',
    regulation: 'Rregullorja',
    vacationrequests: 'Kërkesat për pushim',

    findjobs: 'Gjej punë',
    profileCV: 'Profili juaj',
    appliedpositions: 'Aplikimet për punë',
    ratingsbyinterviews: 'Vlerësimet',

    notifications: 'Njoftime',
    nnotifications: 'Njoftimet',

    savedjobs: 'Konkursete ruajtura',

    registerascompany: 'Regjistrohu si Kompani',
    registerasjobseeker: 'Regjistrohu si punëkërkues',
    forgetpw: 'Kam harruar fjalëkalimin',
    details: 'Detaje',

    settingaccount: 'Llogaria'
  },

  alerts: {
    are_you_sure: 'Jeni të sigurt?',
    are_you_sure_delete: 'Jeni të sigurt?',
    confirm: 'Konfirmo',
    successful_login: 'Kyçja është bërë me sukses',
    invalid_credentials: 'Të dhënat nuk janë korrekte',
    successful_logout: "Ç'kyçja është bërë me sukses",
    successful_register: 'Regjistrimi është bërë me sukses',
    successful_account_activation: 'Llogaria juaj është aktivizuar',
    successful_account_reset_email: 'Ju do merrni një email së shpjeti',
    successful_data_loaded: 'Të dhënat janë ngarkuar.',
    successful_data_updated: 'Data është përditësuar.',
    successful_data_deleted: 'Të dhënat janë fshirë.',
    successful_data_saved: 'Të dhënat janë ruajtur.',
    only_images: 'Ju lutemi zgjidhni një file - foto',
    image_too_big:
      'Dosja juaj është shumë e madhe! Ju lutemi zgjidhni një foto nën 2 MB',
    candidate_rating_completed: 'Kandidati është vlersuar',
    package_activation_request_has_been_sent:
      'Kërkesa për aktivizimin e modulit është dërguar me sukses.',
    successfully_applied_to_job: 'Aplikimi juaj u krye me sukses!',
    successfuly_password_changed: 'Fjalëkalimi është ndryshuar me sukses.',
    successfuly_employee_added_salary_list:
      'Punonjësi është shtuar në listën e pagave me sukses.',
    monthly_salary_generated_succesffuly:
      'Pagat mujore janë gjeneruar me sukses.',
    monthly_salary_generated_succesffuly_for_user:
      'Paoga mujore është gjeneruar me sukses për këtë punonjës.',
    work_schedule_has_been_updated: 'Orari i punës është përditësuar.',
    payment_billing_cycle_update:
      'Cikli i faturimit të pagesës është përditësuar.',
    module_has_been_removed: 'Moduli është hequr nga llogaria e kompanisë.',
    module_price_has_been_updated:
      'Detajet e modulit janë përditësuar për kompaninë aktuale.',
    company_module_invoice_deleted_sucessfully: 'Fatura u fshi me sukses',
    successfull_message_sent:
      "Faleminderit. Mesazhi juaj është dërguar me sukses. Ne do t'ju kontaktojmë së shpejti. ",
    reset_password_sent:
      'Nëse keni një llogari me ne, së shpejti do të merrni një email për të rivendosur fjalëkalimin tuaj.',
    reset_password_completed:
      'Fjalëkalimi juaj është rivendosur. Ju lutemi vazhdoni të kyçeni.',
    accepted_interview: 'Intervista u pranua',
    rejected_interview: 'Intervista u refuzua',
    language_added: 'Gjuha u shtua me sukses',
    language_delete: 'Gjuha u fshi',
    driving_licence_add: 'Licensa u shtua me sukses',
    driving_licence_delete: 'Licensa u fshi',
    same_driving_licence_error: 'Kjo licensë tashmë egziston në CV tënde',
    computerskill_added: 'Aftësia kompjuterike u shtua me sukses',
    education_added: 'Edukimi u shtua me sukses',
    education_delete: 'Edukimi u fshi',
    education_updated: 'Edukimi u ndryshua',
    experience_added: 'Eksperienca u shtua me sukses',
    experience_updated: 'Eksperience u ndryshua',
    experience_delete: 'Eksperienca u fshi',
    training_added: 'Trajnimi | kursi u shtua me sukses',
    training_updated: 'Trajnimi | kursi u ndryshua',
    training_delete: 'Trajnimi | kursi u fshi',
    update_jobseeker: 'Profili juaj u ndryshua',
    image_upload: 'Foto juaj u shtua me sukses',
    noimage: 'Nuk keni zgjedhur imazh',
    saved_job: 'Keni ruajtur punën si të preferuar',
    unsave_job: 'Keni larguar punën nga të preferuarat',
    computerskill_delete: 'Aftësia kompjuterike u fshi',
    otherskill_added: 'Aftësia u shtua me sukses',
    otherskill_delete: 'Aftësia u fshi',
    email_already_taken: 'Ky email egziston',
    same_skill_error: 'Kjo aftësi tashmë egziston në CV tënde',
    same_language_error: 'Kjo gjuhë tashmë egziston në CV tënde',
    name_should_only_container_letters:
      'Emri duhet të përmbajë vetëm karaktere',
    reset_password_token_expired:
      'Ju keni klikuar në butonin Reset Password në emailin tuaj më parë. Ju lutemi provoni të rivendosni përsëri fjalëkalimin tuaj.',
    acceptedinterview: 'Intervista u pranua me sukses',
    rejectinterview: 'Intervista u refuzua me sukses',
    smthwrong: 'Dicka shkoi keq, ju lutem provojeni perseri',
    msgsuccess: 'Mesazhi juaj u dergua',
    sum_of_company_and_employee_with_total_insurance:
      'Shuma e `Pagesa nga kompania` dhe `Pagesa nga punëtori` duhet të jetë e njejtë me `Totalin e sigurimit`',
    total_insurance_more_than_0:
      'Totali i sigurimit duhet të jetë më e madhe se 0'
  },

  inputs: {
    latitude: 'Latitude',
    longitude: 'Longitude',
    radius_km: 'Radius km',
    title: 'Titulli',
    serial_number: 'Numri Serial',
    description: 'Përshkrimi',
    allow_emails_when_generating_wages:
      'Punonjësit do të njoftohen ose do të marrin një email kur kompania të gjenerojë paga',
    select: 'Selekto',
    comment: 'Shto Koment',
    rate_percentage: 'Vlerësimi në %',
    contact_number: 'Numri kontaktues',
    contact_person: 'Personi kontaktues',
    how_do_you_hear_for_us: 'Ku keni degjuar per ne?',
    country: 'Shteti',
    probation: 'Periudha provuese',
    internship: 'Praktikant?',
    maritalstatus: 'Statusi martesor',
    email: 'E-mail',
    password: 'Fjalëkalimi',
    confirm_password: 'Konfirmo fjalëkalimin',
    current_password: 'Fjalëkalimi aktual',
    age: 'Mosha',
    first_name: 'Emri',
    last_name: 'Mbiemri',
    national_id: 'ID shtetërore',
    business_name: 'Emri i biznesit',
    dateOfBirth_desc: 'Datëlindja',
    birthday: 'Datëlindja',
    phone_number: 'Numri i telefonit',
    select_category: 'Zgjedh kategorinë',
    status: 'Status',
    statusjob: 'Statusi i konkursit: ',
    salaryineuro: 'Paga në €',
    jobdsc: 'Përshkrimi i konkursit',
    profession: 'Zgjedh profesionin',
    business_number: 'Numri i biznesit',
    business_fiscal_number: 'Nr i biznesit',
    numberofEmployee: 'Numri i punëtorëve',
    select_country: 'Shteti',
    select_city: 'Qyteti',
    probation_months: 'Periudhë prove - në muaj',
    health_insurance_monthly_cost: 'Kosto e sigurimit shëndetsor - mujore',
    job_title: 'Titulli',
    job_title_desc: 'Javascript developer',
    company_name: 'Emri i kompanisë',
    company_name_desc: 'Emri i kompanisë',
    current_country: 'Shteti aktual',
    training_title: 'Titulli i trajnimit',
    started_date: 'Data e fillimit',
    join_date: 'Data e fillimit',
    join_date_desc: 'Data e fillimit të punës',
    leave_date: 'Data e mbarimit',
    finish_date: 'Data e mbarimit',
    leave_date_desc: 'Data e mbarimit të punës',
    still_work: 'Prezent',
    still_taking: 'Jam prezent në këtë trajnim',
    still_in_education: 'Nuk kam përfunduar',
    job_description: 'Përshkrimi i punës',
    activities_description: 'Aktivitetet',
    select_skill: 'Zgjedh një aftësi',
    select_driving_licence: 'Zgjedh një licens',
    select_language: 'Zgjedh një gjuhë',
    edit_image: 'Ndrysho imazhin',
    edit_profile_image: 'Ndrysho imazhin',
    short_biography: 'Biografi e shkurtër',
    school_name: 'Shkolla',
    school_name_desc: 'Shkolla, universiteti, kolegji',
    field_of_study: 'Drejtimi',
    field_of_study_desc: 'Ekonomik, Juridik...',
    degree: 'Niveli',
    degree_desc: 'Bachelor, Master',
    date_of_birth: 'Datëlindja',
    social_links: 'Rrjetet sociale',
    responsible_name_surname: 'Personi përgjegjës i kompanisë',
    new_password: 'Fjalëkalimi i ri',
    confirm_new_password: 'Konfirmo fjalëkalimin e ri',
    nationality: 'Nacionaliteti',
    address: 'Adresa',
    salaryType: 'Lloji i pagesës',
    job_tags: 'Etiketat',
    employmentType: 'Lloji i punësimit',
    department: 'Departamenti',
    sharewithdepartments:
      'Ndaj me departamentet (lëre bosh që ta ndash me të gjithë)',
    position: 'Pozita',
    start_date: 'Data e fillimit',
    start_date_desc: 'Data e mbarimit të kontratës',
    end_date: 'Data e mbarimit',
    end_date_desc: 'Data kur larguat nga kjo pozitë.',
    conditions: 'Kushtet',
    document_type: 'Lloji i dokumentit',
    document_title: 'Titulli i dokumentit',
    document_description: 'Përshkrimi i dokumentit',
    document_expire_date: 'Data e skadimit të dokumentit',
    expiry_notification_days: 'Ditët e njoftimit para skadimit',
    public_holiday_date: 'Ju lutem shtoni një festë të veçantë publik',
    fiscal_number: 'Numri fiskal',
    fullname: 'Emri i plotë',
    message: 'Mesazh',
    message_desc: 'Ju lutemi shkruani mesazhin tuaj.',
    newpassword_confirm: 'Ju lutemi konfirmoni fjalëkalimin e ri.',
    gender: 'Gjinia',
    female: 'Femër',
    male: 'Mashkull',
    company_ceo: 'CEO i kompanisë',
    companyname: 'Emri kompanisë',
    head_of_hr: 'Shefi i BNJ',
    certificate: 'Çertifikata e biznesit',
    select_member: 'Zgjidhni anëtarin',
    relation: 'Lidhja',
    total_insurance: 'Totali i sigurimit',
    company_insurance: 'Pagesa nga kompania',
    employee_insurance: 'Pagesa nga punëtori',
    locale: 'Zgjidh gjuhën',
    qualification: 'Kualifikimi',
    orientation: 'Orientimi',
    notes: 'Shënimet'
  },

  inputError: {
    targets_required: 'Kërkohen fushat e caktuara',
    national_id_required:
      'ID kombëtare është në formatin e gabuar. Ju lutemi kontrolloni dhe provoni përsëri.',
    old_password:
      'Ju lutemi shkruani fjalëkalimin e vjetër. Kërkohen të paktën 6 karaktere.',
    new_password:
      'Ju lutemi shkruani fjalëkalimin e ri. Kërkohen të paktën 6 karaktere.',
    confirm_new_password:
      'Konfirmoni fjalëkalimin e ri duhet të jetë e njëjtë me fjalëkalimin e ri.',
    invalid_credentials: 'Kredencialet e përdoruesit ishin të pasakta.',
    max_file_upload_size_exceeded:
      'Madhësia e dokumentit tejkaluar 5MB. Ju lutemi ngarkoni një dokument më të vogël',
    upload_file_first: 'Ju lutemi ngarkoni një dokument së pari',
    no_file_added: 'Nuk është shtuar asnjë dokument',
    old_password_invalid:
      'Fjalëkalimi i vjetër është i pavlefshëm. Ju lutemi kontrolloni para se të provoni përsëri.',
    public_holiday_must_be_unique:
      'Ju lutemi shkruani një datë tjetër, datat e festave duhet të jenë unike.',
    already_generated_salary_in_this_month:
      'Ju kanë gjeneruar tashmë pagë për këtë muaj.',
    already_generated_salary_in_this_month_for_this_user:
      'Ky punonjës tashmë ka një pagë të gjeneruar për muajin e zgjedhur.',
    message_required: 'Ju lutemi shkruani mesazhin tuaj',
    fullname_required: 'Ju lutemi shkruani emrin tuaj të plotë',
    phone_number_required: 'Ju lutemi shkruani numrin tuaj të telefonit',
    email_address_unique_required:
      'e-mail i punonjësit duhet të jetë unike. Ju lutemi shtoni një adresë tjetër e-mail.',
    email_already_taken: 'Na vjen keq, ky email është marrë tashmë.',
    fill_all_required_fields: 'Ju lutemi plotësoni të gjitha fushat e kërkuara',
    payroll_not_supported_nmk:
      'Pagat nuk mbështeten ende për kompanitë nga Maqedonia e Veriut.',
    reset_password_token_expired:
      'Ju keni klikuar në butonin Reset Password në emailin tuaj më parë. Ju lutemi provoni të rivendosni përsëri fjalëkalimin tuaj.',
    vacation_dates_already_placed:
      'Ju tashmë keni vendosur një pushim në këto data që keni kërkuar. Ju lutemi ndryshoni datat.',
    required_terms_conditions:
      'Ju lutem lexoni dhe pranoni kushtet e përdorimit.',
    account_type_required: 'Ju lutem zgjedhni llojin e llogarisë.',
    required: 'Kjo fushë është e domosdoshme.',
    check_email: 'Sigurohuni që emaili është shtuar dhe është në rregull.',
    password: 'Kjo fushë është e domosdoshme dhe minium 6 karaktere.',
    confirm_password: 'Fjalëkalimi duhet të jetë i njejtë.',
    terms: 'Ju lutem pranoni kushtet e përdorimit.',
    confirm_dialog_delete: 'A jeni të sigurtë?',
    alert_cannot_add_same_skill:
      'Ju nuk mund të shtoni të njëjtën aftësi. Ju lutem shtoni një tjetër.',
    oneIsRequired: 'Të paktën një zgjedhje është e domosdoshme'
  },

  btn: {
    complete: 'Kompletuar',
    update: 'Ndrysho',
    connect: 'Lidh',
    disconnect: 'Shkëput',
    delete: 'Fshije',
    edit: 'Ndrysho',
    generatewarningletter: 'Gjenero letër vërejtje',
    printbtn: 'Printo',
    generatecontract: 'Gjenero kontratën',
    filtejobsbtn: 'Filtro punë',
    cancelbtn: 'Anulo',
    addbtn: 'Shto',
    viewbtn: 'Shiko',
    updatebtn: 'Ndrysho',
    savebtn: 'Ruaj',
    detailsbtn: 'Detajet',
    backbtn: 'Prapa',
    applynowbtn: 'Apliko',
    applybtn: 'Apliko',
    rejectbtn: 'Refuzo',
    acceptbtn: 'Prano',
    settingaccountbtn: 'Llogaria ime',
    logoutbtn: "Ç'kyçu",
    changepwbtn: 'Ndrysho fjalëkalimin',
    unsave: 'Largo',
    savedjobsbtn: 'Punët e preferuara',
    save: 'Ruaj'
  },

  find_jobs_page: {
    position: 'Pozita',
    at: 'në',
    deadline: 'Afati i fundit',
    category: 'Kategoria',
    country: 'Shteti',
    city: 'Qyteti',
    alredyapplied: 'Tashmë keni aplikuar',
    motivationletter: 'Letër motivimi',
    recommendationletter: 'Letër rekomandimi',
    refferences: 'Referenca',
    motivationletterinput: 'Ju lutem shkruani një letër motivuese këtu',
    recommendationletterinput: 'Ju lutem shkruani një letër rekomandimi këtu',
    refferencesletterinput: 'Ju lutem shkruani referencat këtu',
    searchplaceholder: 'Shkruaj titullin e punës dhe shtyp enter',
    sorrynojobs: 'Nuk ka punë aktive për momentin!',
    sorrynofavoritejobs: 'Nuk keni asnjë punë të preferuar!'
  },

  find_jobs_page_filter: {
    filterjobstxt: 'Filtro punë',
    filterjobstxt2: 'Shfaq listën e punëve në bazë të filtrimeve',
    filterbycountry: 'Filtro sipas shtetit',
    filterbycity: 'Filtro sipas qytetit',
    filterbycategory: 'Filtro sipas kategorisë',
    filterbysavedjobs: 'Filtro sipas punëve të preferuara',
    selectcountry: 'Zgjedh shtetin',
    selectcity: 'Zgjedh qytetin',
    selectcategory: 'Zgjedh kategorinë',
    applyfilterbtn: 'Filtro',
    filterbysalarytype: 'Filtro sipas llojit të pagës',
    selectsalarytype: 'Zgjedh llojin e pagës',
    filterbyemptype: 'Filtro sipas llojit të punësimit',
    selectemptype: 'Zgjedh llojin e punësimit',
    savedjobs: 'Punët e preferuara',

    searchbytitle: 'Kërko sipas titullit'
  },

  applied_positions_jobseeker_page: {
    position: 'Pozita',
    category: 'Kategoria',
    country: 'Shteti',
    city: 'Qyteti',
    applicationstatus: 'Statusi',
    new_application: 'Aplikim i ri',
    rejected_candidate: 'Aplikim i refuzuar',
    blacklist_candidate: 'Aplikim i refuzuar',
    accepted_interview: 'Intervistë e pranuar',
    invited_to_interview: 'I ftuar për intervistë',
    rejected_interview: 'Intervistë e refuzuar',
    potential_candidate: 'Kandidat potencial',
    hired_candidate: 'Kandidat i punësuar',
    nojobapplicationtxt: 'Nuk keni aplikuar në asnjë punë!',
    dscnewapplication: 'Aplikim i ri',
    dsctypeinterview: 'Lloji i intervistës',
    dscdescriptioninterview: 'Përshkrimi',
    dscdateandtimeinterview: 'Data dhe koha',
    dscdate: 'Data',
    dsctime: 'Koha',
    dscrejected: 'Aplikimi është refuzuar',
    dscrejectedinterview: 'Intervista është refuzuar',
    dscpotentialcandidate: 'Jeni zgjedhur si kandidat potencial',
    dschiredcandidate:
      'Ju jeni punësuar për këtë pozitë. Kompania do ju kontaktojë së shpejti'
  },

  jobseeker_ratings_page: {
    position: 'Pozita',
    category: 'Kategoria',
    country: 'Shteti',
    city: 'Qyteti',
    backbtn: 'Prapa',
    detailsbtn: 'Detajet',
    nojobapplicationnoratingstxt:
      'Nuk jeni vlerësuar nga asnjë kompani sepse nuk keni aplikuar për punë!',
    averagerate: 'Vlerësimi mesatar',
    none: 'Asnjë',
    rates: 'Vlerësimet',
    rateEducation: 'Edukimi',
    rateExperience: 'Eksperienca',
    rateLanguage: 'Gjuhët e huaja',
    rateGeneralKnowledge: 'Njohuri të përgjithshme',
    rateJudgement: 'Aftësia për të gjykuar',
    rateKnowledgePosition: 'Njohuri rreth pozitës',
    rateLogical: 'Logjike',
    rateITSkills: 'Aftësit në IT',
    rateOtherSkills: 'Aftësit tjera'
  },

  setting_account_page: {
    settingaccounttxt: 'Llogaria',
    myaccounttxt: 'Llogaria ime',
    notificationtxt: 'Njoftimet',
    privacytxt: 'Privatësia',
    accountinformationtxt: 'Informacionet e llogarisë',
    mainaccountinfotxt: 'Të dhënat kryesore të llogarisë',
    changepwtxt: 'Ndrysho fjalëkalimin',
    changepwdsctxt: 'Mund të ndryshoni fjalëkalimin e llogarisë këtu'
  },

  language_proficiency: {
    Beginner: 'Fillestar',
    Advanced: 'Avancuar',
    Average: 'Mesatare',
    Excellent: 'Shkëlqyeshëm',
    Professional: 'Profesional',
    reading: 'Të lexuarit',
    understanding: 'Të kuptuarit',
    speaking: 'Të folurit',
    writing: 'Të shkruarit',
    ELEMENTARY: 'Elementare',
    LIMITED_WORKING: 'E limituar për punë',
    PROFESSIONAL_WORKING: 'Për punë profesionale',
    FULL_PROFESSIONAL: 'Aftësi të zgjeruara profesionale',
    NATIVE: 'Gjuhë amë',
    proficiency: 'Aftësia'
  },

  your_profile_cv: {
    no_experience: 'Nuk keni të dhëna për eksperiencë',
    show_file: 'Shiko dosjen',
    no_file: 'Nuk ka dosje',
    no_logo: 'Nuk ka foto',
    present: 'Prezent',
    actions: 'ndrysho | fshij',
    edit: 'Ndrysho',
    delete: 'Fshij',
    cancel: 'Anulo',
    add_experience: 'Shto eksperiencë',
    add_experience_1: 'Shto eksperiencën tënde të punës',
    position: 'Pozita',
    check_uncheck: 'check | uncheck',
    add_document: 'Shto dosje',
    image_company: 'Shto logo të kompanisë',
    alredy_have_image: 'Ju keni një logo për kompaninë',
    edit_experience: 'Ndrysho eksperiencën',
    alredy_have_document:
      'Ju keni një dosje. Shtoni një të re nëse dëshironi ta ndryshoni atë',

    no_education: 'Nuk keni të dhëna për edukim',
    school_name: 'Shkolla',
    field_study: 'Drejtimi',
    from_to: 'prej - deri',
    level_education: 'Niveli',
    city: 'Qyteti',
    country: 'Shteti',
    file: 'Dosja',
    add_education: 'Shto edukimin',
    add_education_1: 'Shto edukimin që keni ndjekur',
    other_degree: 'Nivel tjetër',
    other_field_study: 'Drejtim tjeetër',
    edit_education: 'Ndrysho edukimin',

    no_training: 'Nuk keni të dhëna për trajnime | kurse',
    institution: 'Institucioni',
    training_course: 'Trajnim | Kurs',
    add_training: 'Shto trajnimin | kursin',
    add_training_1: 'Shto trajnimet | kurset që keni ndjekur',
    edit_training: 'Ndrysho trajnimin | kursin',

    no_language: 'Nuk keni të dhëna për gjuhë',
    language: 'Gjuha',
    add_language: 'Shto gjuhë',
    add_language_1: 'Zgjedh gjuhën që ju e dini',

    no_c_skill: 'Nuk keni të dhëna për aftësi kompjuterike',
    skill: 'Aftësia',
    level: 'Niveli',
    add_c_skill: 'Shto aftësitë kompjuterike',
    add_c_skill_1: 'Shto aftësitë që ju i keni',
    select_skill: 'Zgjedh aftësinë',
    select_level: 'Zgjedh nivelin',

    no_o_skill: 'Nuk keni të dhëna për aftësi tjera',
    add_o_skill: 'Shto aftësi tjera',
    add_o_skill_1: 'Shto aftësitë që ju i keni',

    no_driving: 'Nuk ka të dhëna për licensa',
    add_driving: 'Shto licensë',
    add_driving_1: 'Shto licensën që ju e keni',
    category_license: 'Kategoritë'
  },

  notifications: {
    requested_vacation: 'Kërkes pushimi.',
    job_new_application: 'Aplikuar për',
    admin_approved_package_request:
      'Administratori miratoi kërkesën tuaj për aktivizimin e paketës',
    invited_interview: 'Ju ftoi në intervistë për',
    rejected_interview: 'Refuzoi aplikimin tuaj për',
    rated_profile: 'Vlerësuar CV-në tuaj'
  },

  page_titles: {
    company_jobs: 'Punët në kompani',
    add_new_job: 'Shto punë të re',
    candidate_interviews: 'Intervistat e kandidatëve',
    rated_candidates: 'Kandidatët e vlerësuar',
    company_employees: 'punonjësit e kompanisë',
    main_profile_data: 'Të dhënat kryesore të profilit',
    employees_salary_list: 'Lista e pagave të punonjësve',
    assign_employee: 'Caktoni punonjësin',
    generated_salaries: 'Pagat e gjeneruara'
  },

  navigation: {
    search_jobs: 'Kërko punë',
    resume: 'Rezymeja',
    download_resume: 'Shkarkoni rezymen',
    applied_positions: 'Pozita të aplikuara',
    ratings: 'Vlerësime',
    account_settings: 'Llogarisë settings',
    no_notification: 'Ju nuk keni ndonjë njoftim të ri.',
    all_notifications: 'Të gjitha njoftimet',
    mark_all_as_read: 'Shënoji të gjitha si të lexuar',
    logout: 'Shkyç',
    feeds: 'Feeds',
    recruitment: 'Rekrutimi',
    jobs: 'Punë',
    interviews: 'Intervistat',
    blacklist: 'Listë e zezë',
    employees: 'Punonjësit',
    all_employees: 'Të gjithë punonjësit',
    birthdays: 'Ditëlindjet',
    performance_settings: 'Performanca settings',
    work_schedule: 'Orari i punes',
    vacations: 'Pushimet',
    vacation_requests: 'Kërkesat për pushime',
    public_holiday_settings: 'Festave publike settings',
    general_vacation_settings: 'Pushime të përgjithshme settings',
    finances: 'Financat',
    employee_salaries: 'Pagat e punonjësve',
    generate_salaries: 'Gjeneroni paga',
    payment_settings: 'Pagesa settings',
    organogram: 'Organogrami',
    regulations: 'Rregulloret',
    dress_code: 'Kodi i veshjes',
    profile: 'Profili',
    work_details: 'Detajet e punës',
    performance: 'Performanca',
    documents: 'Dokumentet',
    salary: 'Paga'
  },

  button: {
    create_cv: 'krijoni Cv tuaj',
    are_you_a_company: 'A jeni kompani?',
    cancel: 'Anulo',
    close: 'Mbyll',
    save: 'Ruaj',
    export: 'Eksporto',
    update: 'Përditëso',
    chooseImage: 'Zgjidhe foto',
    removeImage: 'Hiq foto',
    rate: 'Vlerësoni',
    reject: 'Refuzo',
    book_time_off: 'Rezervoni kohën e lirë',
    send_message: 'Dërgoni mesazh',
    save_job_details: 'Ruaj detajet e punës',
    back: 'Prapa',
    next: 'Vazhdo'
  },

  authentication_page: {
    signup: 'Regjistrohu',
    createaccount: 'Krijo llogari',
    company: 'Kompani',
    jobseeker: 'Punëkërkues',
    nav_button_create_account: 'Krijo llogari',
    next_step_button: 'Hapi tjetër',
    login_button: 'Kyçu',
    reset_button: 'Rivendos fjalëkalimin',
    create_account_button: 'Krijo llogari',
    continue: 'Vazhdo',
    auth_main_title: 'Krijo një llogari me HR bee Management.',
    auth_main_title_desc: 'Zgjidhni llojin e përdoruesit që ju përfaqëson',
    box_jobseeker_title: 'Punëkërkues',
    box_jobseeker_title_desc:
      'Ju jeni një individ ku kërkoni të punësoheni në një punëdhënës.',
    box_jobseeker_title_checbox: 'Unë jam një punëkërkues',
    box_employer_title: 'PUNËDHËNËS',
    box_employer_title_desc:
      'Ju jeni një person juridik që kërkon të punësojë punëkërkuesit.',
    box_employer_title_checbox: 'Unë jam një punëdhënës',
    account_page_title: 'Detajet për llogarinë',
    business_account_page_title: 'Informatat mbi biznesin tuaj',
    account_page_title_desc:
      'Ju lutem plotësoni të dhënat më poshtë për të krijuar llogarinë.',
    jobseeker_account_login_button: 'Kyçu në llogari',
    terms_conditions_1: 'Unë i kam lexuar dhe pranoj',
    terms_conditions_2: 'kushtet e përdorimit',
    auth_bottom_links_forgot_1: 'Kam llogari, por kam harruar',
    auth_bottom_links_forgot_2: 'fjalëkalimin.',
    auth_bottom_links_login_1: 'Kam llogari dhe dua të',
    auth_bottom_links_login_2: 'kyçem.',
    auth_bottom_links_login_3: 'Kam llogari dhe dua të',
    auth_bottom_links_login_4: 'kyçem!'
  },

  businessCategories: {
    administrate: 'Llogaritar',
    agronomi: 'Agronomi',
    arkitekture: 'Arkitekturë',
    arsim_edukim: 'Arsim',
    banka_financa: 'Bankë & Financë',
    call_center: 'Qendra e thirrjeve',
    hoteleri_turizem: 'Hotel & Turizëm',
    inxhinieri: 'Inxhinieri',
    juridik: 'Jurist',
    kontabilitet: 'Kontabiliteti',
    logjistike: 'Logjistikë',
    marketing_reklamim: 'Marketingu & Reklamimi',
    media: 'Media',
    menaxhment: 'Menaxhimi',
    ndertimtari: 'Ndërtim',
    prodhimtari: 'Prodhimtari',
    sherbime_shendetsore: 'Shërbime shëndetësore',
    sherbime_klienteve: 'Shërbimet e klientit',
    shitje: 'Shitje',
    sigurime: 'Sigurime',
    sport: 'Sport',
    teknologji_informative: 'Teknologji informative - IT',
    telekomunikacion: 'Telekomunikacion',
    tjera: 'Të tjera',
    trajnim_konsulence: 'Trajnim & Këshillim'
  },

  jobseeker_profile_page: {
    tab_education: 'Edukimi',
    tab_driving_skills: 'Licensa',
    tab_experience: 'Përvoja punës',
    tab_training_courses: 'Trajnimet/Kurset',
    tab_languages: 'Gjuhët',
    tab_computer_skills: 'Aftësit kompjuterike',
    tab_other_skills: 'Aftësit të tjera'
  },

  package_modules: {
    pricingofpackages: 'Pricing of packages',
    package: 'Pako',
    free: 'Falas',
    basic: 'Bazik',
    standart: 'Standard',
    premium: 'Premium',
    loadingbtn: 'Se shpejti',

    feeds: 'Moduli i Njoftimeve',
    recruitment: 'Moduli i rekrutimit',
    management: 'Moduli i menaxhimit',
    workSchedule: 'Moduli i orarit të punës',
    vacation: 'Moduli i pushimeve',
    wages: 'Moduli i pagave',
    training: 'Moduli i Trajnimeve',
    performance: 'Moduli i Performances',
    timeLineProject: 'Modli i Projekteve',
    insurance: 'Moduli i Sigurimit',
    buttonGetStarted: 'Fillo',

    nopackages: 'Kompania nuk ka pako aktive'
  },

  EducationFieldStudies: {
    Primary: 'Fillore',
    music: 'Muzik',
    dance: 'Vallëzim',
    theatre: 'Teatër',
    film_studies: 'Studime Filmi',
    fine_arts: 'Arte të bukura',
    applied_arts: 'Arte të Aplikuara',
    animation: 'Animacion',
    calligraphy: 'Kaligrafia',
    decorative_arts: 'Arte dekorative',
    mixed_media: 'Media e Përzier',
    printmaking: 'Bërje shtypi',
    studio_art: 'Arti Studio',
    architecture: 'Arkitekturë',
    design: 'Dizajn',
    history: 'Histori',
    languages_and_literature: 'Gjuhët dhe Letërsia',
    linguistics: 'Gjuhësia',
    comparative_literature: 'Literatura krahasuese',
    creative_writing: 'Shkrim kreativ',
    english_literature: 'Letërsi angleze',
    history_of_literature: 'Historia e Letërsisë',
    literary_theory: 'Teoria letrare',
    poetry: 'Poezi',
    world_literature: 'Letërsia Botërore',
    philosophy: 'Filozofi',
    aesthetics: 'Estetikë',
    epistemology: 'Epistemologjia',
    ethics: 'Etika',
    history_of_philosophy: 'Historia e Filozofisë',
    logic: 'Logjika',
    meta_philosophy: 'Filozofia Meta',
    metaphysics: 'Metafizika',
    philosophical_movement: 'Lëvizja Filozofike',
    political_philosophy: 'Filozofi Politike',
    theology_: 'Teologji',
    biblical_studies: 'Studime Biblike',
    religious_studies: 'Studimet fetare',
    aramaic: 'Aramaik',
    buddhist_devotion: 'Përkushtimi Budist',
    christian_theology: 'Teologjia e krishterë',
    hindu_theology: 'Teologji Hindu',
    jewish_theology: 'Teologji hebraike',
    muslim_theology: 'Teologjia Myslimane',
    social_sciences: 'Shkencat shoqërore',
    biological_anthropology: 'Antropologji biologjike',
    linguistic_anthropology: 'Antropologji gjuhësore',
    cultural_anthropology: 'Antropologji kulturore',
    social_anthropology: 'Antropologjia Sociale',
    archaeology: 'Arkeologji',
    agricultural_economics: 'Ekonomi Bujqësore',
    anarchist_economics: 'Ekonomi Anarkiste',
    applied_economics: 'Ekonomi e Aplikuar',
    behavioural_economics: 'Ekonomi e Sjelljes',
    bioeconomics: 'Bioekonomi',
    complexity_economics: 'Ekonomi e Kompleksitetit',
    computational_economics: 'Ekonomi llogaritëse',
    consumer_economics: 'Ekonomi e Konsumatorit',
    development_economics: 'Ekonomia e Zhvillimit',
    ecological_economics: 'Ekonomi Ekologjike',
    econometrics: 'Ekonometria',
    economic_geography: 'Gjeografia ekonomike',
    economic_history: 'Histori Ekonomike',
    economic_sociology: 'Sociologjia ekonomike',
    economic_systems: 'Sistemet Ekonomike',
    energy_economics: 'Ekonomia e Energjisë',
    entrepreneurial_economics: 'Ekonomi Sipërmarrëse',
    environmental_economics: 'Ekonomi e mjedisit',
    evolutionary_economics: 'Ekonomi evolucionare',
    experimental_economics: 'Ekonomi Eksperimentale',
    feminist_economics: 'Ekonomi Feministe',
    financial_econometrics: 'Ekonometria financiare',
    financial_economics: 'Ekonomi financiare',
    green_economics: 'Ekonomia e Gjelbër',
    economic_growth: 'Rritja ekonomike',
    human_development_theory: 'Teoria e Zhvillimit Njerëzor',
    industrial_organization: 'Organizata Industriale',
    information_economics: 'Ekonomia e Informacionit',
    institutional_economics: 'Ekonomia Institucionale',
    international_economics: 'Ekonomi Ndërkombëtare',
    islamic_economics: 'Ekonomia Islame',
    labor_economics: 'Ekonomia e Punës',
    law_and_economics: 'Ligji dhe Ekonomia',
    macroeconomics: 'Makroekonomia',
    managerial_economics: 'Ekonomi menaxheriale',
    marxian_economics: 'Ekonomi Marksiane',
    mathematical_economics: 'Ekonomi Matematike',
    microeconomics: 'Mikroekonomi',
    monetary_economics: 'Ekonomi monetare',
    neuroeconomics: 'Neuroekonomia',
    participatory_economics: 'Ekonomi me Pjesëmarrje',
    political_economy: 'Ekonomi politike',
    public_economics: 'Ekonomi Publike',
    public_finance: 'Financa Publike',
    real_estate_economics: 'Ekonomi e pasurive të patundshme',
    resource_economics: 'Ekonomia e Burimeve',
    social_choice_theory: 'Teoria e Zgjedhjes Sociale',
    socialist_economics: 'Ekonomia Socialiste',
    socioeconomics: 'Socioekonomi',
    transport_economics: 'Ekonomia e Transportit',
    welfare_economics: 'Ekonomi e mirëqenies',
    marketing: 'Marketingu',
    human_geography: 'Gjeografia njerëzore',
    administrative_law: 'E drejta administrative',
    canon_law: 'Ligji i Kanunit',
    civil_law: 'Ligji civil',
    comparative_law: 'E Drejta Krahasuese',
    competition_law: 'Ligji i Konkurrencës',
    constitutional_law: 'Ligji kushtetues',
    criminal_law: 'E drejta penale',
    'sharia|islamic_law': 'Sheriati | Ligji Islam',
    jewish_law: 'Ligji hebre',
    jurisprudence: 'Jurisprudence',
    legal_management: 'Menaxhimi Ligjor',
    procedural_law: 'Ligji procedural',
    substantive_law: 'E drejta materiale',
    politics_of_canada: 'Politika e Kanadasë',
    civics: 'Qytetarët',
    comparative_politics: 'Politika krahasuese',
    european_studies: 'Studime Evropiane',
    geopolitics: 'Gjeopolitika',
    international_relations: 'Marrëdhëniet Ndërkombëtare',
    international_organizations: 'Organizatat ndërkombëtare',
    nationalism_studies: 'Studimet e nacionalizmit',
    peace_and_conflict_studies: 'Studimet e Paqes dhe Konfliktit',
    policy_studies: 'Studimet e politikave',
    theories_of_political_behavior: 'Teoritë e Sjelljes Politike',
    political_culture: 'Kultura politike',
    political_history: 'Political History',
    psephology: 'Psefologji',
    abnormal_psychology: 'Psikologji anormale',
    applied_psychology: 'Psikologji e Aplikuar',
    asian_psychology: 'Psikologji Aziatike',
    biological_psychology: 'Biological Psychology',
    black_psychology: 'Psikologjia e Zezë',
    clinical_neuropsychology: 'Neuropsikologji klinike',
    clinical_psychology: 'Psikologji klinike',
    cognitive_psychology: 'Psikologji njohëse',
    community_psychology: 'Psikologjia e Komunitetit',
    comparative_psychology: 'Psikologji krahasuese',
    conservation_psychology: 'Psikologji Konservimi',
    consumer_psychology: 'Psikologji e Konsumatorit',
    counseling_psychology: 'Psikologji Këshillimi',
    criminal_psychology: 'Psikologji kriminale',
    cultural_psychology: 'Psikologji Kulturore',
    developmental_psychology: 'Psikologjia e Zhvillimit',
    differential_psychology: 'Psikologji diferenciale',
    ecological_psychology: 'Psikologji ekologjike',
    educational_psychology: 'Psikologji Edukative',
    environmental_psychology: 'Psikologji mjedisore',
    evolutionary_psychology: 'Psikologji evolucionare',
    experimental_psychology: 'Psikologji Eksperimentale',
    group_dynamics: 'Dinamika e grupeve',
    journal_of_family_psychology: 'Gazeta e Psikologjisë Familjare',
    feminine_psychology: 'Psikologji Femërore',
    forensic_developmental_psychology: 'Psikologjia e Zhvillimit Ligjor',
    forensic_psychology: 'Psikologji Ligjore',
    health_psychology: 'Psikologji shëndetësore',
    humanistic_psychology: 'Psikologji Humaniste',
    indigenous_psychology: 'Psikologji autoktone',
    legal_psychology: 'Psikologji Ligjore',
    masculine_psychology: 'Psikologji mashkullore',
    mathematical_psychology: 'Psikologji matematike',
    media_psychology: 'Psikologji mediatike',
    medical_psychology: 'Medical Psychology',
    military_psychology: 'Psikologji Ushtarake',
    descriptive_ethics: 'Etika përshkruese',
    music_psychology: 'Psikologji muzikore',
    neuropsychology: 'Neuropsikologji',
    occupational_health_psychology: 'Psikologji e Shëndetit në Punë',
    occupational_psychology: 'Psikologji e Punës',
    industrial_and_organizational_psychology:
      'Psikologji Industriale dhe Organizative',
    parapsychology: 'Parapsikologjia',
    pediatric_psychology: 'Psikologji Pediatrike',
    pedology: 'Pedology',
    personality_psychology: 'Psikologji e personalitetit',
    phenomenology: 'Fenomenologjia',
    political_psychology: 'Psikologji Politike',
    positive_psychology: 'Psikologji Pozitive',
    psychoanalysis: 'Psikoanaliza',
    psychobiology: 'Psikobiologji',
    psychology_of_religion: 'Psikologjia e Fesë',
    psychometrics: 'Psychometrics',
    psychopathology: 'Psikopatologjia',
    psychophysics: 'Psikofizikë',
    quantitative_psychology: 'Psikologji sasiore',
    rehabilitation_psychology_journal:
      'Revista e Psikologjisë së Rehabilitimit',
    school_psychology: 'Psikologji Shkolla',
    social_psychology: 'Psikologji Sociale',
    sport_psychology: 'Psikologji Sporti',
    traffic_psychology: 'Psikologji e Trafikut',
    transpersonal_psychology: 'Psikologji Transpersonale',
    analytical_sociology: 'Sociologji analitike',
    applied_sociology: 'Sociologji e Zbatuar',
    collective_behavior: 'Sjellja kolektive',
    chinese_sociology: 'Sociologji kineze',
    community_informatics: 'Komuniteti Informatika',
    comparative_sociology: 'Sociologji krahasuese',
    conflict_theories: 'Teoritë e konflikteve',
    criminology: 'Kriminologjia',
    critical_management_studies: 'Studime të Menaxhimit Kritik',
    critical_sociology: 'Sociologji Kritike',
    cultural_sociology: 'Sociologji kulturore',
    cultural_studies: 'Studime Kulturore',
    demography: 'Demografia',
    digital_sociology: 'Sociologji Dixhitale',
    dramaturgical_sociology: 'Sociologji dramaturgjike',
    educational_sociology: 'Sociologji Edukative',
    empirical_sociology: 'Sociologji empirike',
    environmental_sociology: 'Sociologji mjedisore',
    evolutionary_sociology: 'Sociologji evolucionare',
    feminist_sociology: 'Sociologji Feministe',
    figurational_sociology: 'Sociologji figurative',
    futures_studies: 'Studime të së Ardhmes',
    gender_studies: 'Studime Gjinore',
    historical_sociology: 'Sociologji Historike',
    human_ecology: 'Ekologjia njerëzore',
    humanistic_sociology: 'Sociologji Humaniste',
    industrial_sociology: 'Sociologji industriale',
    interactionism: 'Ndërveprimi',
    interpretive_sociology: 'Sociologji interpretuese',
    jealousy_sociology: 'Sociologjia e xhelozisë',
    macrosociology: 'Makrosociologjia',
    marxist_sociology: 'Sociologji Marksiste',
    mathematical_sociology: 'Mathematical Sociology',
    medical_sociology: 'Sociologji Mjekësore',
    mesosociology: 'Mesosociologjia',
    microsociology: 'Mikrosociologji',
    military_sociology: 'Sociologji Ushtarake',
    natural_resource_sociology: 'Sociologjia e Burimeve Natyrore',
    organizational_studies: 'Studime Organizative',
    phenomenological_sociology: 'Phenomenological Sociology',
    policy_sociology: 'Policy Sociology',
    psychoanalytic_sociology: 'Psychoanalytic Sociology',
    science_studies: 'Science Studies',
    sexology: 'Sexology',
    social_capital: 'Social Capital',
    social_change: 'Social Change',
    social_conflict_theory: 'Social Conflict Theory',
    social_control: 'Social Control',
    social_economy: 'Social Economy',
    social_philosophy: 'Social Philosophy',
    social_policy: 'Social Policy',
    social_research: 'Social Research',
    social_stratification: 'Social Stratification',
    social_theory: 'Social Theory',
    social_transformation: 'Social Transformation',
    sociobiology: 'Sociobiology',
    sociocybernetics: 'Sociocybernetics',
    sociolinguistics: 'Sociolinguistics',
    sociological_theory: 'Sociological Theory',
    gerontology: 'Gerontology',
    rural_sociology: 'Rural Sociology',
    sociology_of_art: 'Sociology Of Art',
    societal_and_cultural_aspects_of_autism:
      'Societal And Cultural Aspects Of Autism',
    sociology_of_the_family: 'Sociology Of The Family',
    social_conflict: 'Social Conflict',
    sociology_of_culture: 'Sociology Of Culture',
    sociology_of_the_internet: 'Sociology Of The Internet',
    development_theory: 'Development Theory',
    deviance_sociology: 'Deviance Sociology',
    sociology_of_disaster: 'Sociology Of Disaster',
    sociology_of_education: 'Sociology Of Education',
    sociology_of_emotions: 'Sociology Of Emotions',
    social_studies_of_finance: 'Social Studies Of Finance',
    sociology_of_food: 'Sociology Of Food',
    sociology_of_gender: 'Sociology Of Gender',
    theory_of_generation: 'Theory Of Generation',
    world_systems_theory: 'World Systems Theory',
    political_sociology: 'Political Sociology',
    sociology_of_health_and_illness: 'Sociology Of Health And Illness',
    sociology_of_human_consciousness: 'Sociology Of Human Consciousness',
    sociology_of_immigration: 'Sociology Of Immigration',
    sociology_of_knowledge: 'Sociology Of Knowledge',
    sociology_of_language: 'Sociology Of Language',
    sociology_of_law: 'Sociology Of Law',
    sociology_of_leisure: 'Sociology Of Leisure',
    sociology_of_literature: 'Sociology Of Literature',
    sociomusicology: 'Sociomusicology',
    natural_resource_management: 'Natural Resource Management',
    organizational_behavior: 'Organizational Behavior',
    sociology_of_peace: 'Sociology Of Peace',
    sociology_of_punishment: 'Sociology Of Punishment',
    sociology_of_race_and_ethnic_relations:
      'Sociology Of Race And Ethnic Relations',
    sociology_of_religion: 'Sociology Of Religion',
    'risk|sociology_of_risk': 'Risk|Sociology Of Risk',
    sociology_of_scientific_knowledge: 'Sociology Of Scientific Knowledge',
    social_movement: 'Social Movement',
    sociology_of_space: 'Sociology Of Space',
    sociology_of_sport: 'Sociology Of Sport',
    'science,_technology_and_society': 'Science, Technology And Society',
    sociology_of_terrorism: 'Sociology Of Terrorism',
    sociology_of_the_body: 'Sociology Of The Body',
    sociology_of_the_history_of_science: 'Sociology Of The History Of Science',
    structural_sociology: 'Structural Sociology',
    theoretical_sociology: 'Theoretical Sociology',
    urban_sociology: 'Urban Sociology',
    victimology: 'Victimology',
    visual_sociology: 'Visual Sociology',
    aerobiology: 'Aerobiology',
    anatomy: 'Anatomy',
    biochemistry: 'Biochemistry',
    bioinformatics: 'Bioinformatics',
    biophysics: 'Biophysics',
    biotechnology: 'Biotechnology',
    botany: 'Botany',
    cell_biology: 'Cell Biology',
    chronobiology: 'Chronobiology',
    computational_biology: 'Computational Biology',
    cryobiology: 'Cryobiology',
    developmental_biology: 'Developmental Biology',
    ecology: 'Ecology',
    endocrinology: 'Endocrinology',
    evolutionary_biology: 'Evolutionary Biology',
    genetics: 'Genetics',
    histology: 'Histology',
    human_biology: 'Human Biology',
    immunology: 'Immunology',
    limnology: 'Limnology',
    linnaean_taxonomy: 'Linnaean Taxonomy',
    marine_biology: 'Marine Biology',
    mathematical_biology: 'Mathematical Biology',
    microbiology: 'Microbiology',
    molecular_biology: 'Molecular Biology',
    mycology: 'Mycology',
    neuroscience: 'Neuroscience',
    nutrition: 'Nutrition',
    paleobiology: 'Paleobiology',
    parasitology: 'Parasitology',
    pathology: 'Pathology',
    physiology: 'Physiology',
    structural_biology: 'Structural Biology',
    systematics: 'Systematics',
    systems_biology: 'Systems Biology',
    virology: 'Virology',
    xenobiology: 'Xenobiology',
    zoology: 'Zoology',
    agrochemistry: 'Agrochemistry',
    analytical_chemistry: 'Analytical Chemistry',
    astrochemistry: 'Astrochemistry',
    atmospheric_chemistry: 'Atmospheric Chemistry',
    chemical_biology: 'Chemical Biology',
    chemical_engineering: 'Chemical Engineering',
    cheminformatics: 'Cheminformatics',
    computational_chemistry: 'Computational Chemistry',
    cosmochemistry: 'Cosmochemistry',
    electrochemistry: 'Electrochemistry',
    environmental_chemistry: 'Environmental Chemistry',
    femtochemistry: 'Femtochemistry',
    flavor: 'Flavor',
    flow_chemistry: 'Flow Chemistry',
    geochemistry: 'Geochemistry',
    green_chemistry: 'Green Chemistry',
    histochemistry: 'Histochemistry',
    hydrogenation: 'Hydrogenation',
    immunochemistry: 'Immunochemistry',
    inorganic_chemistry: 'Inorganic Chemistry',
    marine_chemistry: 'Marine Chemistry',
    mathematical_chemistry: 'Mathematical Chemistry',
    mechanochemistry: 'Mechanochemistry',
    medicinal_chemistry: 'Medicinal Chemistry',
    molecular_mechanics: 'Molecular Mechanics',
    nanotechnology: 'Nanotechnology',
    natural_product_chemistry: 'Natural Product Chemistry',
    neurochemistry: 'Neurochemistry',
    oenology: 'Oenology',
    organic_chemistry: 'Organic Chemistry',
    organometallic_chemistry: 'Organometallic Chemistry',
    petrochemistry: 'Petrochemistry',
    pharmacology: 'Pharmacology',
    photochemistry_: 'Photochemistry',
    physical_chemistry: 'Physical Chemistry',
    physical_organic_chemistry: 'Physical Organic Chemistry',
    phytochemistry: 'Phytochemistry',
    polymer_chemistry: 'Polymer Chemistry',
    quantum_chemistry: 'Quantum Chemistry',
    radiochemistry: 'Radiochemistry',
    solid_state_chemistry: 'Solid State Chemistry',
    sonochemistry: 'Sonochemistry',
    supramolecular_chemistry: 'Supramolecular Chemistry',
    surface_chemistry: 'Surface Chemistry',
    synthetic_chemistry: 'Synthetic Chemistry',
    theoretical_chemistry: 'Theoretical Chemistry',
    thermochemistry: 'Thermochemistry',
    edaphology: 'Edaphology',
    environmental_science: 'Environmental Science',
    gemology: 'Gemology',
    geodesy: 'Geodesy',
    physical_geography: 'Physical Geography',
    geophysics: 'Geophysics',
    paleontology: 'Paleontology',
    astrobiology: 'Astrobiology',
    astronomy: 'Astronomy',
    astrophysics: 'Astrophysics',
    interstellar_medium: 'Interstellar Medium',
    direct_numerical_simulation: 'Direct Numerical Simulation',
    physical_cosmology: 'Physical Cosmology',
    'star|stellar_astrophysics': 'Star|Stellar Astrophysics',
    planetary_science: 'Planetary Science',
    _physics_: 'Physics',
    acoustics: 'Acoustics',
    applied_physics: 'Applied Physics',
    'atomic,_molecular': 'Atomic, Molecular',
    computational_physics: 'Computational Physics',
    condensed_matter_physics: 'Condensed Matter Physics',
    cryogenics: 'Cryogenics',
    electromagnetism: 'Electromagnetism',
    elementary_particle_physics: 'Elementary Particle Physics',
    experimental_physics: 'Experimental Physics',
    fluid_dynamics: 'Fluid Dynamics',
    mathematical_physics: 'Mathematical Physics',
    mechanics: 'Mechanics',
    medical_physics: 'Medical Physics',
    molecular_physics: 'Molecular Physics',
    newtons_laws_of_motion: 'Newtons Laws Of Motion',
    nuclear_physics: 'Nuclear Physics',
    optics: 'Optics',
    plasma_physics: 'Plasma Physics',
    quantum_physics: 'Quantum Physics',
    solid_mechanics: 'Solid Mechanics',
    solid_state_physics: 'Solid State Physics',
    statistical_mechanics: 'Statistical Mechanics',
    theoretical_physics: 'Theoretical Physics',
    thermodynamics: 'Thermodynamics',
    vehicle_dynamics: 'Vehicle Dynamics',
    computer_science: 'Computer Science',
    logic_in_computer_science: 'Logic In Computer Science',
    algorithms: 'Algorithms',
    artificial_intelligence: 'Artificial Intelligence',
    data_structures: 'Data Structures',
    computer_architecture: 'Computer Architecture',
    computer_graphics: 'Computer Graphics',
    computer_networking: 'Computer Networking',
    high_availability: 'High Availability',
    medicine: 'Medicine',
    professions: 'Professions',
    distributed_computing: 'Distributed Computing',
    human_computer_interaction: 'Human Computer Interaction',
    operating_systems: 'Operating Systems',
    parallel_computing: 'Parallel Computing',
    programming_languages: 'Programming Languages',
    quantum_computing: 'Quantum Computing',
    software_engineering: 'Software Engineering',
    theory_of_computation: 'Theory Of Computation',
    very_large_scale_integration: 'Very Large Scale Integration',
    mathematics: 'Mathematics',
    foundations_of_mathematics: 'Foundations Of Mathematics',
    algebra: 'Algebra',
    mathematical_analysis: 'Mathematical Analysis',
    probability_theory: 'Probability Theory',
    topology: 'Topology',
    number_theory: 'Number Theory',
    approximation_theory: 'Approximation Theory',
    combinatorics: 'Combinatorics',
    cryptography: 'Cryptography',
    dynamical_systems: 'Dynamical Systems',
    game_theory: 'Game Theory',
    graph_theory: 'Graph Theory',
    information_theory: 'Information Theory',
    numerical_analysis: 'Numerical Analysis',
    operations_research: 'Operations Research',
    statistics: 'Statistics',
    astrostatistics: 'Astrostatistics',
    biostatistics: 'Biostatistics',
    bioengineering: 'Bioengineering',
    catalysis: 'Catalysis',
    materials_engineering: 'Materials Engineering',
    molecular_engineering: 'Molecular Engineering',
    polymer_engineering: 'Polymer Engineering',
    process_design: 'Process Design',
    process_engineering: 'Process Engineering',
    reaction_engineering: 'Reaction Engineering',
    transport_phenomena: 'Transport Phenomena',
    coastal_engineering: 'Coastal Engineering',
    earthquake_engineering: 'Earthquake Engineering',
    ecological_engineering: 'Ecological Engineering',
    environmental_engineering: 'Environmental Engineering',
    geotechnical_engineering: 'Geotechnical Engineering',
    hydraulic_engineering_: 'Hydraulic Engineering',
    mining_engineering: 'Mining Engineering',
    transportation_engineering: 'Transportation Engineering',
    structural_engineering: 'Structural Engineering',
    structural_mechanics: 'Structural Mechanics',
    surveying: 'Surveying',
    instructional_design: 'Instructional Design',
    human_performance_technology: 'Human Performance Technology',
    knowledge_management: 'Knowledge Management',
    computer_engineering: 'Computer Engineering',
    control_engineering: 'Control Engineering',
    electronic_engineering: 'Electronic Engineering',
    engineering_physics: 'Engineering Physics',
    mechatronics: 'Mechatronics',
    power_engineering: 'Power Engineering',
    robotics: 'Robotics',
    semiconductors: 'Semiconductors',
    telecommunications_engineering: 'Telecommunications Engineering',
    biomaterials: 'Biomaterials',
    ceramic_engineering: 'Ceramic Engineering',
    crystallography: 'Crystallography',
    nanomaterials: 'Nanomaterials',
    photonics: 'Photonics',
    metallurgy: 'Metallurgy',
    polymer_science: 'Polymer Science',
    aerospace_engineering: 'Aerospace Engineering',
    acoustical_engineering: 'Acoustical Engineering',
    automotive_engineering: 'Automotive Engineering',
    biomedical_engineering: 'Biomedical Engineering',
    continuum_mechanics: 'Continuum Mechanics',
    fluid_mechanics: 'Fluid Mechanics',
    heat_transfer: 'Heat Transfer',
    industrial_engineering: 'Industrial Engineering',
    manufacturing_engineering: 'Manufacturing Engineering',
    marine_propulsion: 'Marine Propulsion',
    mass_transfer: 'Mass Transfer',
    nanoengineering: 'Nanoengineering',
    offshore_construction: 'Offshore Construction',
    optical_engineering: 'Optical Engineering',
    vehicle_engineering: 'Vehicle Engineering',
    chaos_theory: 'Chaos Theory',
    complex_system: 'Complex System',
    complex_systems: 'Complex Systems',
    conceptual_systems: 'Conceptual Systems',
    control_theory: 'Control Theory',
    cybernetics: 'Cybernetics',
    network_science: 'Network Science',
    system_dynamics: 'System Dynamics',
    systems_ecology: 'Systems Ecology',
    systems_engineering: 'Systems Engineering',
    systems_psychology: 'Systems Psychology',
    systems_theory: 'Systems Theory',
    systems_theory_in_anthropology: 'Systems Theory In Anthropology',
    medicine_and_health: 'Medicine And Health',
    alternative_medicine: 'Alternative Medicine',
    clinical_laboratory_sciences: 'Clinical Laboratory Sciences',
    clinical_physiology: 'Clinical Physiology',
    dentistry: 'Dentistry',
    dermatology: 'Dermatology',
    emergency_medicine: 'Emergency Medicine',
    geriatrics: 'Geriatrics',
    gynaecology: 'Gynaecology',
    health_informatics: 'Health Informatics',
    hematology: 'Hematology',
    infectious_disease: 'Infectious Disease',
    intensive_care_medicine: 'Intensive Care Medicine',
    internal_medicine: 'Internal Medicine',
    medical_toxicology: 'Medical Toxicology',
    music_therapy: 'Music Therapy',
    nursing: 'Nursing',
    dietetics: 'Dietetics',
    obstetrics: 'Obstetrics',
    occupational_hygiene: 'Occupational Hygiene',
    occupational_therapy: 'Occupational Therapy',
    occupational_toxicology: 'Occupational Toxicology',
    ophthalmology: 'Ophthalmology',
    optometry: 'Optometry',
    otolaryngology: 'Otolaryngology',
    pediatrics: 'Pediatrics',
    pharmaceutical_sciences: 'Pharmaceutical Sciences',
    physical_fitness: 'Physical Fitness',
    physical_therapy: 'Physical Therapy',
    physiotherapy: 'Physiotherapy',
    podiatry: 'Podiatry',
    preventive_healthcare: 'Preventive Healthcare',
    primary_care: 'Primary Care',
    psychiatry: 'Psychiatry',
    psychology: 'Psychology',
    public_health: 'Public Health',
    radiology: 'Radiology',
    recreational_therapy: 'Recreational Therapy',
    physical_medicine_and_rehabilitation:
      'Physical Medicine And Rehabilitation',
    respiratory_therapy: 'Respiratory Therapy',
    sleep_medicine: 'Sleep Medicine',
    speech_language_pathology: 'Speech Language Pathology',
    sports_medicine: 'Sports Medicine',
    surgery: 'Surgery',
    traditional_medicine: 'Traditional Medicine',
    urology: 'Urology',
    veterinary_medicine: 'Veterinary Medicine',
    other: 'Other'
  },

  EducationDegrees: {
    ps: 'Shkolla fillore (ShF)',
    hs: 'Shkolla e mesme (ShM)',
    prs: 'Shkolla Profesionale (ShP)',
    st: 'Student (ST)',
    ba: 'Bachelor (BA)',
    ma: 'Master (MA)',
    phd: 'Dr/ (PhD)',
    other: 'Tjeter'
  }
}
